import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from 'simple-react-validator';
import dayjs from 'dayjs';
import { Input, LabelText, Button, SpanText, SubmitButton, FlexContainer, H1Text, LeftBackButtonText, Hr, Text, SelectBox, Img, InputWrapper, Spinner, CancelButton } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import EditIcon from "../../assets/imgs/edit.svg";
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import BackArrow from "../../assets/imgs/backarrow.svg";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";
import { axiosAuthInstance, API, BASE_URLS, axiosEmptyInstance } from "../../api";
import { SWIREPAY_URL, USA_STATES, BUSINESS_TYPES, BUSINESS_REPRESENTATIVES, INDIAN_STATES, BANK_ACCOUNT_TYPE, ISSUER_BANK_ACCOUNT_TYPE, PRODUCT_OPTIONS } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import { isValidPhoneNumber } from 'libphonenumber-js';
// import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date';
import { Tag, DatePicker, Steps, Tooltip, Alert, Checkbox, Row, Col } from 'antd';
import PlaidLinkOpener from "../../utils/PlaidLinkOpener";
import { DeleteOutlined, SyncOutlined } from "@ant-design/icons";
import addIcon from '../../assets/imgs/Add_Circled_Icon.svg';
import PolicyConfirmationModal from "./components/PolicyConfirmationModal";
import { useSelector } from "react-redux";
import styled from 'styled-components';

type Props = {
    history: {
        push: Function,
    },
}

const ProductCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 15px;
  height: 100%;
  display: flex;
  align-items: center;
  transition: border-color 0.3s;
  
  &:hover {
    border-color: #1890ff;
  }

  .ant-checkbox-wrapper {
    width: 100%;
    span {
      font-size: ${(props) => (props.isMobile ? '18px' : '14px')};
    }
  }
`;

const PartnerBusiness = (props: Props) => {
    const [, forceUpdate] = useState();
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showerrorMessage, setShowErrorMessage] = useState(false);
    const [step, setStep] = useState(1);
    const [affilateData, setAffilateData] = useState('');
    const [userData, setUserData] = useState('');
    const [isReview, setIsReview] = useState(false);
    const publicKey = localStorage.getItem('publicKey');
    const [showPassword, setShowPassword] = useState(false);
    const [familyName, setFamilyName] = useState('');
    const [givenName, setGivenName] = useState('');
    const [bankName, setBankName] = useState('');
    const [accntName, setAccntName] = useState('');
    const [accntNumber, setAccntNumber] = useState('');
    const [routeNumber, setRouteNumber] = useState('');
    const isTest = publicKey ? publicKey.split('_')[1] : '';
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [bussinessTypes, setBusinessTypes] = useState(BUSINESS_TYPES.US);
    const bankAccountType = BANK_ACCOUNT_TYPE;
    const [stateList, setStateList] = useState(USA_STATES);
    const [zipLabel, setZipLabel] = useState('Zip code');
    const [fileValidate, setFileValidate] = useState('');
    const [kycBankStatement, setKycBankStatement] = useState('No file chosen');
    const [kycRegistrationProof, setKycRegistrationProof] = useState('No file chosen');
    const [kycCompanyPan, setKycCompanyPan] = useState('No file chosen');
    const [kycAddressProofUrl1, setKycAddressProofUrl1] = useState('No file chosen');
    const [kycAddressProofUrl2, setKycAddressProofUrl2] = useState('No file chosen');
    const [countryName, setCountryName] = useState();
    const [currentAddress, setCurrentAddress] = useState('No file chosen');
    const [boardResolution, setBoardResolution] = useState('No file chosen');
    const [gstCertificate, setGstCertificate] = useState('No file chosen');
    const [eightyGCertificate, setEightyGCertificate] = useState('No file chosen');
    const [panProofUrl1, setPanProofUrl1] = useState('No file chosen');
    const [panProofUrl2, setPanProofUrl2] = useState('No file chosen');
    const [controlError, setControlError] = useState('');
    const [panProofUrl3, setPanProofUrl3] = useState('No file chosen');
    const [panProofUrl4, setPanProofUrl4] = useState('No file chosen');
    const [kycAddressProofUrl3, setKycAddressProofUrl3] = useState('No file chosen');
    const [kycAddressProofUrl4, setKycAddressProofUrl4] = useState('No file chosen');
    const [voidCheckProof, setVoidCheckProof] = useState('No file chosen');
    const [govtAddressProofUrl1, setGovtAddressProofUrl1] = useState('No file chosen');
    const [govtAddressProofUrl2, setGovtAddressProofUrl2] = useState('No file chosen');
    const [govtAddressProofUrl3, setGovtAddressProofUrl3] = useState('No file chosen');
    const [govtAddressProofUrl4, setGovtAddressProofUrl4] = useState('No file chosen');
    const [panProofFileError1, setPanProofFileError1] = useState('');
    const [panProofFileError2, setPanProofFileError2] = useState('');
    const [panProofFileError3, setPanProofFileError3] = useState('');
    const [panProofFileError4, setPanProofFileError4] = useState('');
    const [idProofFileError1, setIdProofFileError1] = useState('');
    const [idProofFileError2, setIdProofFileError2] = useState('');
    const [idProofFileError3, setIdProofFileError3] = useState('');
    const [idProofFileError4, setIdProofFileError4] = useState('');
    const [plaidAccessToken, setPlaidAccessToken] = useState('');
    const [openPlaid, setOpenPlaid] = useState(false);
    const [policyConfirmation, setPolicyConfirmation] = useState(true);
    const [unProceed, setUnProceed] = useState(false);
    const ifNumber = /^[0-9]+$/;
    const amountRegex = /^\d*\.?\d*$/;
    const descriptorRegex = /[<>'"*]/;
    const einRegex = /^([07][1-7]|1[0-6]|2[0-7]|[35][0-9]|[468][0-8]|9[0-589])-?\d{7}$/;
    const [products, setProducts] = useState([]);
    const isProcessingInfoRequired = !(products && products?.length === 1 && products?.includes('ACCOUNT_PAYABLES'));
    const { isMobileView } = useSelector((store) => store.appConfigInfo);

    useEffect(() => {
        if (publicKey) {
            getData();
        }
        if (isTest === 'test') {
            setBankName('Swirepay Test Bank');
            setAccntName('Swirepay Test User');
            setAccntNumber('000123456789');
            setRouteNumber('122105155');
        }
    }, []);

    const getPlaidToken = async (accountGid) => {
        try {
        const { data: { entity } } = await axiosAuthInstance.post(`/integration/plaid/${accountGid}/create-secure-link-token`, {
          useMerchantName: false,
        });
        if (entity?.token) {
            setPlaidAccessToken(entity?.token);
        }
        } catch (e) {
        console.log('e', e);
        }
    };

    const getData = async () => {
        setShowSpinner(true);
        try {
            const { data: { entity: userEntity } } = await axiosAuthInstance.get(BASE_URLS.USER_PROFILE);
            const config = {
                headers: {
                    'x-api-key': publicKey,
                }
            };
            const { data } = await API.get(BASE_URLS.GET_ACCOUNT, config);
            const cntryInfo = data && data.entity && data.entity.country;
            setCountryName(cntryInfo && cntryInfo.alpha2);
            if (data?.entity?.gid) {
                getPlaidToken(data?.entity?.gid)
            };
            if (userEntity && userEntity.user) {
                setUserData(userEntity.user);
                setGivenName(userEntity.user.givenName);
                setFamilyName(userEntity.user.familyName);
                localStorage.removeItem('email');
            }
        } catch (e) {
            setShowErrorMessage(true);
            setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
        } finally {
            setShowSpinner(false);
        }
    };

    const simpleValidator = useRef(new SimpleReactValidator({
        validators: {
            validUrl: {
                message: 'Please enter a valid Business Website',
                rule: val => (new RegExp('^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$').exec(val) !== null),
            },
            confirmAccount: {
                message: 'Must match account number typed above',
                rule: (val, params) => val === params[0],
            },
            validAccountNumber: {
                message: 'Please enter valid Bank account number',
                rule: val => (new RegExp(/^[0-9]{6,17}$/).exec(val) !== null),
            },
            validRoutingNumber: {
                message: 'Please enter valid Bank Routing number',
                rule: val => (new RegExp(/^[0-9]{9}$/).exec(val) !== null),
            },
            validSSN: {
                message: 'Please enter valid SSN number',
                rule: val => (new RegExp(/^[0-9]{9}$/).exec(val) !== null),
            },
            validTaxId: {
                message: 'Please enter valid Fed Tax Id',
                rule: val => (new RegExp(/^[0-9]{9}$/).exec(val) !== null),
            },
            validPAN: {
                message: 'Please enter valid PAN number',
                rule: val => (new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/).exec(val) !== null),
            },
            validCIN: {
                message: 'Please enter valid CIN number',
                rule: val => (new RegExp(/^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/).exec(val) !== null),
            },
            validLLP: {
                message: 'Please enter valid LLP ID',
                rule: val => (new RegExp(/[a-zA-Z0-9]{7}/).exec(val) !== null),
            },
            validGST: {
                message: 'Please enter valid GST',
                rule: val => (new RegExp(/^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/).exec(val) !== null),
            },
            validTAN: {
                message: 'Please enter valid TAN',
                rule: val => (new RegExp(/^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/).exec(val) !== null),
            },
            validName: {
                message: 'Please enter a valid name',
                rule: val => /^[A-Za-z0-9\s\-.,'$@_]{4,}$/.test(val),
            },
            EIN: {
                message: 'Please enter valid EIN',
                rule: val => einRegex.test(val),
            },
            phoneNumValidation: {
                message: 'The phone number is invalid',
                rule: (val, param) => /^[0-9]+$/.test(val) && isValidPhoneNumber(param[0]),
            },
            ownerShip: {
                message: 'Percentage ownership should be equal or more than 25% and equal or less than 100%',
                rule: (val) => {
                    const value = val && val.replace('%', '');
                    return (ifNumber.test(value) && (value >= 25) && (value <= 100));
                },
            },
            minamount: {
                message: 'Amount should be min 0 max 999999999',
                rule: (val) => Number(val) >= 0,
            },
            maxamount: {
                message: 'Amount should be min 0 max 999999999',
                rule: (val) => Number(val) <= 999999999,
            },
            descriptor: {
                message: 'Statement Descriptor min 5 and max 22 characters',
                // eslint-disable-next-line max-len
                rule: val => val && val.length >= 5 && val.length <= 22 && !descriptorRegex.test(val) && Boolean(val.charAt(0).match(/[a-zA-Z]/)) && Boolean(val.charAt(val.length - 1).match(/[a-zA-Z]/)),
            },
            checkLowerCase: {
                message: 'Email address must not contain uppercase letters.',
                rule: (val) => val === val.toLowerCase(),
            },
            averageTicketAmountCheck: {
                message: 'Average ticket amount should be less than average monthly amount',
                rule: (val, params) => Number(val) < Number(params[0]),
            },
            productRequired: {
                message: 'Please select at least one product',
                rule: val => Array.isArray(val) && val.length > 0,
            },
        },
    }));

    simpleValidator.current.purgeFields();

    const [modeTransactionError, setModeTransactionError] = useState('');

    const [bussinessDetails, setBussinessDetails] = useState([{
        country: '',
        bussinessType: '',
        name: '',
        website: '',
        businessPan: '',
        kycBankStatementUrl: '',
        kycCompanyPanUrl: '',
        kycRegistrationProofUrl: '',
        currentAddressProofUrl: '',
        boardResolutionUrl: '',
        gstCertificateUrl: '',
        eightyGAndTwelveACertificate: '',
        gst: '',
        tan: '',
        phoneNumber: '',
        isTaxExemptOrganisation: '',
        companyyear: '',
        companymonth: '',
        companyday: '',
        employerIdNumber: null,
        statementDescriptor: '',
        accountName: '',
    }]);
    const [representativeDetails, setRepresentativeDetails] = useState(BUSINESS_REPRESENTATIVES.US_REPRESENTATIVES);
    const [bussinessAddress, setBussinessAddress] = useState([{
        streetAddress: '',
        city: '',
        state: '',
        zipCode: '',
    }]);
    const [payoutDetails, setPayoutDetails] = useState([{
        bankType: '',
        existingBankType: '',
        bankName: '',
        accountHolderName: '',
        accountNumber: '',
        confirmAccountNumber: '',
        bankRoutingNumber: '',
        employerIdNumber: null,
        averageMonthlyVolume: '',
        averageTicketAmount: '',
        servicesDeliveredIn: '',
        refundPolicy: '',
        seasonalBusiness: '',
        isServiceDateFlexible: '',
        whenIsCardCharged: '',
        serviceyear: '',
        servicemonth: '',
        serviceday: '',
        modeOfTransactionOnline: '',
        modeOfTransactionPerson: '',
        modeOfTransactionOnline1: '',
        modeOfTransactionPerson1: '',
        isEbt: false,
        voidCheckUrl: '',
        plaidPublicToken: null,
    }]);

    const fileReader = async file => new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.readAsArrayBuffer(file);
    });


    const getPersonValue = (val) => {
        if (val === '0%') {
            return 0
        } else if (val === '25%') {
            return 25
        } else if (val === '50%') {
            return 50
        } else if (val === '75%') {
            return 75
        } else if (val === '100%') {
            return 100
        }
    }

    useEffect(() => {
      if (products && products?.length === 1 && products?.includes('ACCOUNT_RECEIVABLES_ONLINE')) {
        setPayoutDetails((prev) => [{
          ...prev[0],
          modeOfTransactionOnline: '100%',
          modeOfTransactionOnline1: 100,
          modeOfTransactionPerson: '0%',
          modeOfTransactionPerson1: 0
        }]);
      } else if (products && products?.length === 1 && products?.includes('ACCOUNT_RECEIVABLES_POS')) {
        setPayoutDetails((prev) => [{
          ...prev[0],
          modeOfTransactionOnline: '0%',
          modeOfTransactionOnline1: 0,
          modeOfTransactionPerson: '100%',
          modeOfTransactionPerson1: 100
        }]);
      }
    }, [products]);

    useEffect(() => {
      if (!isProcessingInfoRequired) {
        setPayoutDetails((prev) => {
          const list = [...prev];
          // Reset all the fields that are hidden when this is false
          list[0].averageMonthlyVolume = '';
          list[0].averageTicketAmount = '';
          list[0].servicesDeliveredIn = '';
          list[0].refundPolicy = '';
          list[0].seasonalBusiness = '';
          list[0].whenIsCardCharged = '';
          list[0].isServiceDateFlexible = '';
          list[0].serviceyear = '';
          list[0].servicemonth = '';
          list[0].serviceday = '';
          // Also reset mode of transaction if necessary
          list[0].modeOfTransactionOnline = '';
          list[0].modeOfTransactionPerson = '';
          list[0].modeOfTransactionOnline1 = '';
          list[0].modeOfTransactionPerson1 = '';
          return list;
        });
        setModeTransactionError('');
      }
    }, [isProcessingInfoRequired]);

    const getDraftData = async () => {
        const { data: { entity } } = await axiosAuthInstance.get(BASE_URLS.CONNECT_ACCOUNT_DRAFT);
        if (entity) {
            const draftCountry = entity?.countryCode || countryName;
            const parseDateOfBirth = (dateStr) => {
                const [year, month, day] = dateStr.split('-');
                return {
                    year: parseInt(year),
                    month: parseInt(month) - 1,
                    day: parseInt(day)
                };
            };
            const removeCountryCode = (phoneNumber) => {
                if (phoneNumber.startsWith('+1')) {
                    return phoneNumber.slice(2); // removes +1
                } else if (phoneNumber.startsWith('+91')) {
                    return phoneNumber.slice(3);
                }
                return phoneNumber;
            };
            setProducts(entity?.account?.selectedProducts || []);
            setBusinessTypes(draftCountry === 'IN' ? BUSINESS_TYPES.IN : BUSINESS_TYPES.US);
            setStateList(draftCountry === 'IN' ? INDIAN_STATES : USA_STATES);
            setZipLabel(draftCountry === 'IN' ? 'Zip code' : 'Postal Code');
            setBussinessDetails([{
                country: draftCountry === 'US' ? 'USA' : draftCountry === 'IN' ? 'IN' : '',
                bussinessType: entity?.usBusiness?.type || entity?.inBusiness?.type || '',
                name: entity?.usBusiness?.name || entity?.inBusiness?.name || '',
                website: entity?.usBusiness?.url || entity?.inBusiness?.url || '',
                businessPan: entity?.inBusiness?.businessPan || '',
                kycBankStatementUrl: entity?.inBusiness?.kycBankStatementUrl || '',
                kycCompanyPanUrl: entity?.inBusiness?.kycCompanyPanUrl || '',
                kycRegistrationProofUrl: entity?.inBusiness?.kycRegistrationProofUrl || '',
                currentAddressProofUrl: entity?.inBusiness?.currentAddressProofUrl || '',
                boardResolutionUrl: entity?.inBusiness?.boardResolutionUrl || '',
                gstCertificateUrl: entity?.inBusiness?.gstCertificateUrl || '',
                eightyGAndTwelveACertificate: '',
                gst: entity?.inBusiness?.gst || '',
                tan: entity?.inBusiness?.tan || '',
                phoneNumber: entity?.usBusiness?.businessPhoneNumber ? removeCountryCode(entity?.usBusiness?.businessPhoneNumber) : '',
                isTaxExemptOrganisation: entity?.usBusiness?.isTaxExemptOrganisation === true ? 'Yes' : entity?.usBusiness?.isTaxExemptOrganisation === false ? 'No' : '',
                companyyear: entity?.usBusiness?.companyStartDate ? parseDateOfBirth(entity?.usBusiness?.companyStartDate).year : '',
                companymonth: entity?.usBusiness?.companyStartDate ? parseDateOfBirth(entity?.usBusiness?.companyStartDate).month : '',
                companyday: entity?.usBusiness?.companyStartDate ? parseDateOfBirth(entity?.usBusiness?.companyStartDate).day : '',
                employerIdNumber: entity?.usBusiness?.ein || null,
                statementDescriptor: entity?.inBusiness?.statementDescriptor || entity?.usBusiness?.statementDescriptor || '',
                accountName: entity?.account?.name || '',
            }]);
            if (entity?.usBusinessReps || entity?.inBusinessReps) {
                let draftReps = representativeDetails;
                if (entity?.usBusinessReps?.length > 0) {
                    draftReps = entity?.usBusinessReps.map((item) => {
                        return {
                            year: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).year : '',
                            month: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).month : '',
                            day: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).day : '',
                            ssn: item?.ssn || '',
                            title: item?.title || '',
                            firstName: item?.givenName || '',
                            lastName: item?.familyName || '',
                            hasControl: item?.hasControl || false,
                            governmentIdUrl: item?.governmentIdUrl || '',
                            ownerShipPercentage: item?.ownerShipPercentage || '',
                            email: item?.email || '',
                            repPhoneNumber: item?.phone ? removeCountryCode(item?.phone) : '',
                            streetAddress: item?.address?.street || '',
                            city: item?.address?.city || '',
                            state: item?.address?.state || '',
                            zipCode: item?.address?.postalCode || '',
                        }
                    });
                } else if (entity?.inBusinessReps?.length > 0) {
                    draftReps = entity?.inBusinessReps.map((item) => {
                        return {
                            year: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).year : '',
                            month: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).month : '',
                            day: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).day : '',
                            pan: item?.pan || '',
                            title: item?.title || '',
                            firstName: item?.givenName || '',
                            lastName: item?.familyName || '',
                            kycfileName: item?.kycfileName || '',
                            panfileName: item?.panfileName || '',
                            hasControl: item?.hasControl || false,
                            kycAddressProofUrl: item?.kycAddressProofUrl || '',
                            businessRepPanUrl: item?.businessRepPanUrl || '',
                            email: item?.email || '',
                            repPhoneNumber: item?.phone ? removeCountryCode(item?.phone) : '',
                            streetAddress: item?.address?.street || '',
                            city: item?.address?.city || '',
                            state: item?.address?.state || '',
                            zipCode: item?.address?.postalCode || '',
                        }
                    });
                }
                setRepresentativeDetails(draftReps);
            }
            if (entity?.usBusinessReps && entity?.usBusinessReps.length > 0) {
                const draftReps = entity?.usBusinessReps.map((item) => {
                    return {
                        year: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).year : '',
                        month: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).month : '',
                        day: item?.dateofbirth ? parseDateOfBirth(item?.dateofbirth).day : '',
                        ssn: item?.ssn || '',
                        title: item?.title || '',
                        firstName: item?.givenName || '',
                        lastName: item?.familyName || '',
                        hasControl: item?.hasControl || false,
                        governmentIdUrl: item?.governmentIdUrl || '',
                        ownerShipPercentage: item?.ownerShipPercentage || '',
                        email: item?.email || '',
                        repPhoneNumber: item?.phone ? removeCountryCode(item?.phone) : '',
                        streetAddress: item?.address?.street || '',
                        city: item?.address?.city || '',
                        state: item?.address?.state || '',
                        zipCode: item?.address?.postalCode || '',
                    }
                });
                setRepresentativeDetails(draftReps);
            }
            setBussinessAddress([{
                streetAddress: entity?.inBusiness?.address?.street || entity?.usBusiness?.address?.street || '',
                city: entity?.inBusiness?.address?.city || entity?.usBusiness?.address?.city || '',
                state: entity?.inBusiness?.address?.state || entity?.usBusiness?.address?.state || '',
                zipCode: entity?.inBusiness?.address?.postalCode || entity?.usBusiness?.address?.postalCode || '',
            }]);
            setPayoutDetails([{
                bankName: entity?.inBusiness?.bankName || entity?.usBusiness?.bankName || '',
                accountHolderName: entity?.inBusiness?.bankBeneficiaryName || entity?.usBusiness?.bankBeneficiaryName || '',
                accountNumber: entity?.inBusiness?.bankAccountNumber || entity?.usBusiness?.bankAccountNumber || '',
                confirmAccountNumber: entity?.inBusiness?.bankAccountNumber || entity?.usBusiness?.bankAccountNumber || '',
                bankRoutingNumber: entity?.inBusiness?.bankIfscCode || entity?.usBusiness?.bankRoutingNumber || '',
                employerIdNumber: entity?.inBusiness?.cin || entity?.usBusiness?.ein || null,
                averageMonthlyVolume: entity?.usBusiness?.averageMonthlyVolume ? (entity?.usBusiness?.averageMonthlyVolume / 100) : '',
                averageTicketAmount: entity?.usBusiness?.averageTicketAmount ? (entity?.usBusiness?.averageTicketAmount / 100) : '',
                servicesDeliveredIn: entity?.usBusiness?.servicesDeliveredIn || '',
                refundPolicy: entity?.usBusiness?.refundPolicy || '',
                seasonalBusiness: entity?.usBusiness?.seasonalBusiness ? "true" : "false",
                isServiceDateFlexible: entity?.usBusiness?.isServiceDateFlexible ? "true" : "false",
                whenIsCardCharged: entity?.usBusiness?.whenIsCardCharged || '',
                serviceyear: entity?.usBusiness?.requestedServiceDate ? parseDateOfBirth(entity?.usBusiness?.requestedServiceDate).year : '',
                servicemonth: entity?.usBusiness?.requestedServiceDate ? parseDateOfBirth(entity?.usBusiness?.requestedServiceDate).month : '',
                serviceday: entity?.usBusiness?.requestedServiceDate ? parseDateOfBirth(entity?.usBusiness?.requestedServiceDate).day : '',
                modeOfTransactionOnline: entity?.usBusiness?.modeOfTransactionOnline ? `${entity?.usBusiness?.modeOfTransactionOnline}%` : '',
                modeOfTransactionPerson: entity?.usBusiness?.modeOfTransactionPerson ? `${entity?.usBusiness?.modeOfTransactionPerson}%` : '',
                modeOfTransactionOnline1: entity?.usBusiness?.modeOfTransactionOnline ? getPersonValue(`${entity?.usBusiness?.modeOfTransactionOnline}%`) : '',
                modeOfTransactionPerson1: entity?.usBusiness?.modeOfTransactionPerson ? getPersonValue(`${entity?.usBusiness?.modeOfTransactionPerson}%`) : '',
                isEbt: entity?.usBusiness?.isEbt ? true : false,
                voidCheckUrl: entity?.usBusiness?.voidCheckUrl || '',
                plaidPublicToken: entity?.usBusiness?.bankType === 'ISSUER_BANK' ? entity?.usBusiness?.plaidPublicToken : '', // this field is no longer used and will not be set
                bankType: entity?.usBusiness?.bankType || '',
                existingBankType: entity?.usBusiness?.bankType === 'ISSUER_BANK' && entity?.usBusiness?.bankName ? 'MANUAL' : (entity?.usBusiness?.externalAuth ? 'PLAID' : ''),
                externalAuth: entity?.usBusiness?.externalAuth, // if already plaid verified, then this field is set
            }]);
            localStorage.setItem('createVirtualAccount', entity?.account?.createVirtualAccount);
        };
    }

    useEffect(() => {
        getDraftData();
    }, [countryName]);


    const addAnotherRepresntative = () => {
        if (countryName === 'US') {
            setRepresentativeDetails([...representativeDetails, {
                year: '',
                month: '',
                day: '',
                ssn: '',
                title: '',
                firstName: '',
                lastName: '',
                hasControl: false,
                governmentIdUrl: '',
                ownerShipPercentage: '',
                email: '',
                repPhoneNumber: '',
                streetAddress: '',
                city: '',
                state: '',
                zipCode: '',
            },
            ]);
        } else {
            setRepresentativeDetails([...representativeDetails, {
                year: '',
                month: '',
                day: '',
                pan: '',
                title: '',
                firstName: '',
                lastName: '',
                kycfileName: '',
                panfileName: '',
                kycAddressProofUrl: '',
                businessRepPanUrl: '',
                hasControl: true,
                email: '',
                repPhoneNumber: '',
                streetAddress: '',
                city: '',
                state: '',
                zipCode: '',
            },
            ]);
        }
    };

    const removeRepresntative = (id) => {
        const list = [...representativeDetails];
        list.splice(id, 1);
        setRepresentativeDetails(list);
    };

    const isVariableNullOrUndefined = (param) => (typeof (param) !== 'undefined' && param !== null);

    const handleInputChange = async (e, val, i) => {
        let endPoint = '';
        let keyType;
        if (val === 'kycRegistrationProofUrl') {
            endPoint = '/storage/upload/kyc/india/registration';
        } else if (val === 'kycCompanyPanUrl') {
            endPoint = '/storage/upload/kyc/india/company-pan';
        } else if (val === 'kycBankStatementUrl') {
            endPoint = '/storage/upload/kyc/india/bank';
        } else if (val === 'kycAddressProofUrl') {
            endPoint = '/storage/upload/kyc/india/business-rep-address';
        } else if (val === 'currentAddress') {
            endPoint = '/storage/upload/business-current-address';
            keyType = 'BUSINESS_CURRENT_ADDRESS_PROOF';
        } else if (val === 'boardResolution') {
            endPoint = '/storage/upload/board-resolution';
            keyType = 'BUSINESS_BOARD_RESOLUTION_PROOF';
        } else if (val === 'gstCertificate') {
            endPoint = '/storage/upload/gst-certificate';
            keyType = 'BUSINESS_GST_CERTIFICATE';
        } else if (val === 'eightyGCertificate') {
            endPoint = '/storage/upload/eighty-g-and-twelve-a';
            keyType = 'BUSINESS_EIGHTY_G_AND_TWELVE_A_CERTIFICATE';
        } else if (val === 'panProofUrl') {
            endPoint = '/storage/upload/business-rep-pan';
            keyType = 'BUSINESS_REP_PAN';
        } else if (val === 'voidCheckUrl') {
            endPoint = '/storage/upload/us-business-government-id';
        } else if (val === 'governmentIdUrl') {
            endPoint = '/storage/upload/us-business-government-id';
        }
        try {
            const file = e.target.files[0];
            const PDF = 'application/pdf';
            const IMAGE = 'image/*';
            const GIFIMAGE = 'image/gif';
            const pattern = file.type.match(IMAGE) || file.type.match(PDF);
            let gifPattern = true;
            if (file.type.match(GIFIMAGE)) {
                gifPattern = false;
            }
            if (!pattern || !gifPattern) {
                if (val === 'panProofUrl' && i === 0) {
                    setPanProofFileError1('File is not image or pdf');
                } else if (val === 'panProofUrl' && i === 1) {
                    setPanProofFileError2('File is not image or pdf');
                } else if (val === 'panProofUrl' && i === 2) {
                    setPanProofFileError3('File is not image or pdf');
                } else if (val === 'panProofUrl' && i === 3) {
                    setPanProofFileError4('File is not image or pdf');
                } else if (val === 'kycAddressProofUrl' && i === 0) {
                    setIdProofFileError1('File is not image or pdf');
                } else if (val === 'kycAddressProofUrl' && i === 1) {
                    setIdProofFileError2('File is not image or pdf');
                } else if (val === 'kycAddressProofUrl' && i === 2) {
                    setIdProofFileError3('File is not image or pdf');
                } else if (val === 'kycAddressProofUrl' && i === 3) {
                    setIdProofFileError4('File is not image or pdf');
                }
            }
            if (file && pattern && gifPattern) {
                const { data: { entity } } = await axiosAuthInstance.get(endPoint);
                await axiosEmptyInstance.put(entity, await fileReader(file), { headers: { 'Content-Type': file.type } });
                //const { data: { entity: { fileUrl } } } = await axiosAuthInstance.post(endPoint, keyType ? { fileUrl: entity, keyType } : { fileUrl: entity });
                if (val === 'kycRegistrationProofUrl') {
                    bussinessDetails[0].kycRegistrationProofUrl = entity;
                    setKycRegistrationProof(file.name);
                } else if (val === 'kycCompanyPanUrl') {
                    bussinessDetails[0].kycCompanyPanUrl = entity;
                    setKycCompanyPan(file.name);
                } else if (val === 'kycBankStatementUrl') {
                    bussinessDetails[0].kycBankStatementUrl = entity;
                    setKycBankStatement(file.name);
                } else if (val === 'currentAddress') {
                    bussinessDetails[0].currentAddressProofUrl = entity;
                    setCurrentAddress(file.name);
                } else if (val === 'boardResolution') {
                    bussinessDetails[0].boardResolutionUrl = entity;
                    setBoardResolution(file.name);
                } else if (val === 'gstCertificate') {
                    bussinessDetails[0].gstCertificateUrl = entity;
                    setGstCertificate(file.name);
                } else if (val === 'eightyGCertificate') {
                    bussinessDetails[0].eightyGAndTwelveACertificate = entity;
                    setEightyGCertificate(file.name);
                } else if (val === 'kycAddressProofUrl' && i === 0) {
                    representativeDetails[0].kycAddressProofUrl = entity;
                    setIdProofFileError1('');
                    setKycAddressProofUrl1(file.name);
                } else if (val === 'kycAddressProofUrl' && i === 1) {
                    representativeDetails[1].kycAddressProofUrl = entity;
                    setIdProofFileError2('');
                    setKycAddressProofUrl2(file.name);
                } else if (val === 'kycAddressProofUrl' && i === 2) {
                    representativeDetails[2].kycAddressProofUrl = entity;
                    setIdProofFileError3('');
                    setKycAddressProofUrl3(file.name);
                } else if (val === 'kycAddressProofUrl' && i === 3) {
                    representativeDetails[3].kycAddressProofUrl = entity;
                    setIdProofFileError4('');
                    setKycAddressProofUrl4(file.name);
                } else if (val === 'panProofUrl' && i === 0) {
                    representativeDetails[0].businessRepPanUrl = entity;
                    setPanProofFileError1('');
                    setPanProofUrl1(file.name);
                } else if (val === 'panProofUrl' && i === 1) {
                    representativeDetails[1].businessRepPanUrl = entity;
                    setPanProofFileError2('');
                    setPanProofUrl2(file.name);
                } else if (val === 'panProofUrl' && i === 2) {
                    representativeDetails[2].businessRepPanUrl = entity;
                    setPanProofFileError3('');
                    setPanProofUrl3(file.name);
                } else if (val === 'panProofUrl' && i === 3) {
                    representativeDetails[3].businessRepPanUrl = entity;
                    setPanProofFileError4('');
                    setPanProofUrl4(file.name);
                } else if (val === 'voidCheckUrl') {
                    payoutDetails[0].voidCheckUrl = entity;
                    setVoidCheckProof(file.name);
                } else if (val === 'governmentIdUrl' && i === 0) {
                    representativeDetails[0].governmentIdUrl = entity;
                    setGovtAddressProofUrl1(file.name);
                } else if (val === 'governmentIdUrl' && i === 1) {
                    representativeDetails[1].governmentIdUrl = entity;
                    setGovtAddressProofUrl2(file.name);
                } else if (val === 'governmentIdUrl' && i === 2) {
                    representativeDetails[2].governmentIdUrl = entity;
                    setGovtAddressProofUrl3(file.name);
                } else if (val === 'governmentIdUrl' && i === 3) {
                    representativeDetails[3].governmentIdUrl = entity;
                    setGovtAddressProofUrl4(file.name);
                }
                setFileValidate('');
            }
        } catch (error) {
            console.log(error)
        } finally {
        }
    };

    const returnNullIfEmpty = (value) => {
        return value === '' ? null : value;
    }

    const saveAsDraft = async () => {
        let month = parseInt(representativeDetails[0].month) + 1;
        if (month < 10) {
            month = `0${month}`;
        }
        let day = parseInt(representativeDetails[0].day);
        if (day < 10) {
            day = `0${day}`;
        }
        const getDateofBirth = (y, m, d) => {
            let mon = parseInt(m) + 1;
            if (mon < 10) {
                mon = `0${mon}`;
            }
            let days = parseInt(d);
            if (days < 10) {
                days = `0${days}`;
            }
            if (mon === '00') {
                return `${y}-${'01'}-${days}`;
            } else {
                return `${y}-${mon}-${days}`
            };
        }
        let params = {};
        let representativeInfo;
        if (countryName === 'US') {
            representativeInfo = representativeDetails.map((representative, i) => {
                return {
                    ssn: returnNullIfEmpty(representative.ssn),
                    givenName: returnNullIfEmpty(representative.firstName),
                    familyName: returnNullIfEmpty(representative.lastName),
                    title: returnNullIfEmpty(representative.title),
                    phone: representative.repPhoneNumber ? `+1${representative.repPhoneNumber}` : null,
                    email: representative.email ? representative.email : null,
                    kycAddressProofUrl: representative.kycAddressProofUrl || null,
                    address: {
                        city: returnNullIfEmpty(representative.city) || returnNullIfEmpty(bussinessAddress[0].city),
                        countryCode: 'US',
                        deleted: true,
                        postalCode: returnNullIfEmpty(representative.zipCode) || returnNullIfEmpty(bussinessAddress[0].zipCode),
                        state: returnNullIfEmpty(representative.state) || returnNullIfEmpty(bussinessAddress[0].state),
                        street: returnNullIfEmpty(representative.streetAddress) || returnNullIfEmpty(bussinessAddress[0].streetAddress),
                    },
                    dateofbirth: (returnNullIfEmpty(representative.year) !== null && returnNullIfEmpty(representative.month !== null) && returnNullIfEmpty(representative.day !== null))
                        ? getDateofBirth(representative.year, representative.month, representative.day) : null,
                    hasControl: representative.hasControl,
                    ownerShipPercentage: returnNullIfEmpty(representative.ownerShipPercentage),
                    governmentIdUrl: representative.governmentIdUrl || null,
                };
            });
        } else {
            representativeInfo = representativeDetails.map((representative, i) => {
                return {
                    pan: returnNullIfEmpty(representative.pan),
                    givenName: returnNullIfEmpty(representative.firstName),
                    familyName: returnNullIfEmpty(representative.lastName),
                    title: representative.title,
                    phone: representative.repPhoneNumber ? `+91${representative.repPhoneNumber}` : null,
                    email: representative.email ? representative.email : null,
                    kycAddressProofUrl: representative.kycAddressProofUrl || null,
                    businessRepPanUrl: representative.businessRepPanUrl || null,
                    address: {
                        city: returnNullIfEmpty(representative.city),
                        countryCode: 'IN',
                        deleted: true,
                        postalCode: returnNullIfEmpty(representative.zipCode),
                        state: returnNullIfEmpty(representative.state),
                        street: returnNullIfEmpty(representative.streetAddress),
                    },
                    dateofbirth: (returnNullIfEmpty(representative.year) !== null && returnNullIfEmpty(representative.month) !== null && returnNullIfEmpty(representative.day) !== null)
                        ? getDateofBirth(representative.year, representative.month, representative.day) : null,
                    hasControl: returnNullIfEmpty(representative.hasControl),
                };
            });
        }

        if (bussinessDetails[0].country === 'IN') {
            params = {
                account: {
                    name: returnNullIfEmpty(bussinessDetails[0].accountName) || null,
                    countryCode: 'IN',
                    contactEmail: null,
                    contactFamilyName: userData.familyName,
                    contactGivenName: userData.givenName,
                    contactNumber: null,
                    timezone: 'Asia/Kolkata',
                    affiliateCode: null
                },
                inBusiness: {
                    name: returnNullIfEmpty(bussinessDetails[0].name),
                    url: returnNullIfEmpty(bussinessDetails[0].website),
                    shortenedDescriptor: returnNullIfEmpty(payoutDetails[0].accountHolderName) || returnNullIfEmpty(accntName),
                    statementDescriptor: returnNullIfEmpty(bussinessDetails[0].statementDescriptor) || returnNullIfEmpty(accntName),
                    address: {
                        city: returnNullIfEmpty(bussinessAddress[0].city),
                        countryCode: 'IN',
                        deleted: true,
                        postalCode: returnNullIfEmpty(bussinessAddress[0].zipCode),
                        state: returnNullIfEmpty(bussinessAddress[0].state),
                        street: returnNullIfEmpty(bussinessAddress[0].streetAddress)
                    },
                    type: returnNullIfEmpty(bussinessDetails[0].bussinessType),
                    bankName: returnNullIfEmpty(payoutDetails[0].bankName) || returnNullIfEmpty(bankName),
                    bankIfscCode: returnNullIfEmpty(payoutDetails[0].bankRoutingNumber) || returnNullIfEmpty(routeNumber),
                    bankAccountNumber: returnNullIfEmpty(payoutDetails[0].accountNumber) || returnNullIfEmpty(accntNumber),
                    bankBeneficiaryName: returnNullIfEmpty(payoutDetails[0].accountHolderName) || returnNullIfEmpty(accntName),
                    businessPan: returnNullIfEmpty(bussinessDetails[0].businessPan),
                    kycBankStatementUrl: returnNullIfEmpty(bussinessDetails[0].kycBankStatementUrl),
                    kycCompanyPanUrl: returnNullIfEmpty(bussinessDetails[0].kycCompanyPanUrl),
                    kycRegistrationProofUrl: returnNullIfEmpty(bussinessDetails[0].kycRegistrationProofUrl),
                    currentAddressProofUrl: returnNullIfEmpty(bussinessDetails[0].currentAddressProofUrl),
                    boardResolutionUrl: returnNullIfEmpty(bussinessDetails[0].boardResolutionUrl),
                    gstCertificateUrl: returnNullIfEmpty(bussinessDetails[0].gstCertificateUrl),
                    eightyGAndTwelveACertificate: bussinessDetails[0].bussinessType !== 'NONPROFIT_ORGANIZATION' ? null : bussinessDetails[0].eightyGAndTwelveACertificate,
                    plaidPublicToken: returnNullIfEmpty(payoutDetails[0].plaidPublicToken),
                    bankType: returnNullIfEmpty(payoutDetails[0].bankType),
                },
                inBusinessReps: representativeInfo,
            };
        } else if (bussinessDetails[0].country === 'USA') {
            params = {
                account: {
                    name: returnNullIfEmpty(bussinessDetails[0].accountName) || null,
                    countryCode: 'US',
                    contactEmail: null,
                    contactFamilyName: userData.familyName,
                    contactGivenName: userData.givenName,
                    contactNumber: null,
                    timezone: 'America/Los_Angeles',
                    affiliateCode: null,
                    selectedProducts: products,
                },
                usBusiness: {
                    name: returnNullIfEmpty(bussinessDetails[0].name),
                    url: returnNullIfEmpty(bussinessDetails[0].website),
                    shortenedDescriptor: returnNullIfEmpty(payoutDetails[0].accountHolderName) || returnNullIfEmpty(accntName),
                    statementDescriptor: returnNullIfEmpty(bussinessDetails[0].statementDescriptor),
                    address: {
                        city: returnNullIfEmpty(bussinessAddress[0].city),
                        countryCode: 'US',
                        deleted: true,
                        postalCode: returnNullIfEmpty(bussinessAddress[0].zipCode),
                        state: returnNullIfEmpty(bussinessAddress[0].state),
                        street: returnNullIfEmpty(bussinessAddress[0].streetAddress)
                    },
                    type: returnNullIfEmpty(bussinessDetails[0].bussinessType),
                    ein: returnNullIfEmpty(bussinessDetails[0].employerIdNumber),
                    bankName: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].bankName) : null,
                    bankRoutingNumber: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].bankRoutingNumber) : null,
                    bankAccountNumber: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].accountNumber) : null,
                    bankBeneficiaryName: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].accountHolderName) : null,
                    averageMonthlyVolume: payoutDetails[0].averageMonthlyVolume ? parseFloat(payoutDetails[0].averageMonthlyVolume) * 100 : 0,
                    averageTicketAmount: payoutDetails[0].averageTicketAmount ? parseFloat(payoutDetails[0].averageTicketAmount) * 100 : 0,
                    modeOfTransactionOnline: returnNullIfEmpty(payoutDetails[0].modeOfTransactionOnline) && payoutDetails[0].modeOfTransactionOnline.replace('%', ''),
                    modeOfTransactionPerson: returnNullIfEmpty(payoutDetails[0].modeOfTransactionPerson) && payoutDetails[0].modeOfTransactionPerson.replace('%', ''),
                    isEbt: payoutDetails[0].isEbt,
                    servicesDeliveredIn: returnNullIfEmpty(payoutDetails[0].servicesDeliveredIn),
                    seasonalBusiness: payoutDetails[0].seasonalBusiness === "true" ? true : false,
                    refundPolicy: returnNullIfEmpty(payoutDetails[0].refundPolicy),
                    whenIsCardCharged: returnNullIfEmpty(payoutDetails[0].whenIsCardCharged),
                    isServiceDateFlexible: payoutDetails[0].isServiceDateFlexible === "true" ? true : payoutDetails[0].isServiceDateFlexible === "false" ? false : null,
                    requestedServiceDate: (returnNullIfEmpty(payoutDetails[0].serviceyear) !== null && returnNullIfEmpty(payoutDetails[0].servicemonth) !== null && returnNullIfEmpty(payoutDetails[0].serviceday) !== null)
                        ? getDateofBirth(payoutDetails[0].serviceyear, payoutDetails[0].servicemonth, payoutDetails[0].serviceday) : null,
                    isTaxExemptOrganisation: bussinessDetails[0].isTaxExemptOrganisation === "Yes" ? true : bussinessDetails[0].isTaxExemptOrganisation === "No" ? false : null,
                    businessPhoneNumber: bussinessDetails[0].phoneNumber ? `+1${bussinessDetails[0].phoneNumber}` : null,
                    voidCheckUrl: payoutDetails[0].voidCheckUrl || null,
                    companyStartDate: (returnNullIfEmpty(bussinessDetails[0].companyyear) !== null && returnNullIfEmpty(bussinessDetails[0].companymonth) !== null && returnNullIfEmpty(bussinessDetails[0].companyday) !== null)
                        ? getDateofBirth(bussinessDetails[0].companyyear, bussinessDetails[0].companymonth, bussinessDetails[0].companyday) : null,
                    plaidPublicToken: payoutDetails[0].bankType === 'ISSUER_BANK' && payoutDetails[0].existingBankType === 'PLAID' && !payoutDetails[0].externalAuth ? returnNullIfEmpty(payoutDetails[0].plaidPublicToken) : null,
                    externalAuth: payoutDetails[0].bankType === 'ISSUER_BANK' && payoutDetails[0].existingBankType === 'PLAID' && !payoutDetails[0].plaidPublicToken && payoutDetails[0].externalAuth ? returnNullIfEmpty(payoutDetails[0].externalAuth) : null,
                    bankType: returnNullIfEmpty(payoutDetails[0].bankType),
                },
                usBusinessReps: representativeInfo,
            };
        };
        if (bussinessDetails[0].bussinessType === 'LIMITED_LIABILITY_PARTNERSHIP' && bussinessDetails[0].country === 'IN') {
            params.inBusiness.llpin = payoutDetails[0].employerIdNumber;
        } else if (bussinessDetails[0].bussinessType !== 'LIMITED_LIABILITY_PARTNERSHIP' && bussinessDetails[0].bussinessType !== 'PROPRIETORSHIP' && bussinessDetails[0].country === 'IN') {
            params.inBusiness.cin = payoutDetails[0].employerIdNumber;
        }
        if (bussinessDetails[0].gst && bussinessDetails[0].country === 'IN') {
            params.inBusiness.gst = bussinessDetails[0].gst;
        }
        if (bussinessDetails[0].tan && bussinessDetails[0].country === 'IN') {
            params.inBusiness.tan = bussinessDetails[0].tan;
        }
        // this value is fetched from the url search params and set in /connect based component
        const createVirtualAccount = localStorage.getItem('createVirtualAccount');
        if(!params.account) {
            params.account = {};
        }
        if (createVirtualAccount) {
            params.account.createVirtualAccount = createVirtualAccount === 'true';
        } else {
            params.account.createVirtualAccount = false;
        }
        setShowSpinner(true);
        try {
            const { data: { entity } } = await axiosAuthInstance.post(BASE_URLS.CONNECT_ACCOUNT_DRAFT, params);
            if (entity && entity.account) {
                setTransactionModalOpen(true);
            };
            const { nextActionUrl, gid } = entity.account;
            if (nextActionUrl) {
                window.location = nextActionUrl;
                return;
            }
            setTransactionModalOpen(false);
            setTransactionSuccessModalOpen(true);
            setTimeout(function () {
                if (localStorage.getItem('redirectUrl')) {
                    window.location = `${localStorage.getItem('redirectUrl')}?sp-account-id=${gid}`;
                } else {
                    window.location = `${SWIREPAY_URL}?sp-account-id=${gid}`;
                }
            }, 5000);
            localStorage.removeItem('affiliateId');
            localStorage.removeItem('publicKey');
            localStorage.removeItem('createVirtualAccount');
        } catch (reason) {
            setShowErrorMessage(true);
            setErrorMessage(reason && reason.data ? reason.data.message : 'Unable to process request. Please try again later');
        } finally {
            setShowSpinner(false);
        }
    };

    const next = async () => {
        if (step === 1) {
            const formValid = simpleValidator.current.allValid();
            if (!formValid) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            if (isReview) {
                setStep(7);
            } else setStep(step + 1);
            simpleValidator.current.hideMessages();
            setShowErrorMessage(false);
            forceUpdate();
        } else if (step === 2) {
            const formValid = simpleValidator.current.allValid();
            const hasControlValid = representativeDetails.some((item) => item.hasControl);
            if (!hasControlValid) {
                setControlError('At least one director with control is needed. You should not be able to save a business with everybody saying No.');
            }
            let ownership = 0;
            representativeDetails.forEach(obj => {
                if (isVariableNullOrUndefined(obj.ownerShipPercentage)) {
                    ownership += Number(obj.ownerShipPercentage.replace('%', ''));
                }
            });
            if (!formValid) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            if (bussinessDetails[0].country === 'IN') {
                if (!hasControlValid) {
                    simpleValidator.current.showMessages();
                    forceUpdate(1);
                    return;
                }
            }
            if (bussinessDetails[0].country !== 'IN') {
                if (ownership > 100) {
                    setControlError('Cumulative Ownership of all Representatives should not exceed 100%');
                    simpleValidator.current.showMessages();
                    forceUpdate(1);
                    return;
                }
                if (ownership <= 50) {
                    setControlError('Cumulative Ownership of all Representatives should be atleast 51%');
                    simpleValidator.current.showMessages();
                    forceUpdate(1);
                    return;
                }
            }
            setControlError('');
            if (isReview) {
                setStep(7);
            } else setStep(step + 1);
            simpleValidator.current.hideMessages();
            forceUpdate();
            setShowErrorMessage(false);
        } else if (step === 3) {
            const formValid = simpleValidator.current.allValid();
            if (!formValid) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            if (isReview) {
                setStep(7);
            } else setStep(step + 1);
            simpleValidator.current.hideMessages();
            forceUpdate();
            setShowErrorMessage(false);
        } else if (step === 4) {
            let modeofTransaction = true;
            const formValid = simpleValidator.current.allValid();
            if (bussinessDetails[0].country !== 'IN'  && isProcessingInfoRequired) {
                if (payoutDetails[0].modeOfTransactionOnline1 + payoutDetails[0].modeOfTransactionPerson1 !== 100) {
                    modeofTransaction = false;
                    setModeTransactionError('Mode of transaction Online and In Person must add up to 100%');
                } else setModeTransactionError('');
            }
            if (!formValid) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            if (!modeofTransaction) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            if (isReview) {
                setStep(7);
            } else setStep(step + 1);
            simpleValidator.current.hideMessages();
            forceUpdate();
            setShowErrorMessage(false);
        } else if (step === 5) {
            const formValid = simpleValidator.current.allValid();
            if (!formValid) {
                simpleValidator.current.showMessages();
                forceUpdate(1);
                return;
            }
            if (isReview) {
                setStep(6);
            } else setStep(step + 1);
            simpleValidator.current.hideMessages();
            setIsReview(true);
        } else if (step === 6) {
            if (isReview) {
                setStep(7);
            } else setStep(step + 1);
            forceUpdate();
            setShowErrorMessage(false);
            setIsReview(true);
        } else if (step === 7) {
            let month = parseInt(representativeDetails[0].month) + 1;
            if (month < 10) {
                month = `0${month}`;
            }
            let day = parseInt(representativeDetails[0].day);
            if (day < 10) {
                day = `0${day}`;
            }
            const getDateofBirth = (y, m, d) => {
                let mon = parseInt(m) + 1;
                if (mon < 10) {
                    mon = `0${mon}`;
                }
                let days = parseInt(d);
                if (days < 10) {
                    days = `0${days}`;
                }
                return `${y}-${mon}-${days}`;
            }
            let params = {};
            let representativeInfo;
            const param = {
                email: userData.email,
                name: userData.fullName,
                notificationType: "NONE",
                phoneNumber: userData.phoneNumber,
                type: "EMAIL",
            };
            const config = {
                headers: {
                    'x-api-key': publicKey,
                }
            };
            setShowSpinner(true);
            let affilateInfo = null;
            try {
              const affiliateId = localStorage.getItem('affiliateId');
              if (affiliateId) {
                const { data: { entity } } = await API.get(`${BASE_URLS.AFFILIATE_ACCOUNT}/${affiliateId}`, config);
                affilateInfo = entity;
                setAffilateData(entity);
              } else {
                const { data: { entity } } = await API.post(BASE_URLS.AFFILIATE_ACCOUNT, param, config);
                affilateInfo = entity;
                setAffilateData(entity);
              }
            } catch (error) {
               setErrorMessage(error?.data?.message || 'Unable to process, please try again!')
               setShowErrorMessage(true);
               return;
            } finally {
              setShowSpinner(false);
            }
            if (countryName === 'US') {
                representativeInfo = representativeDetails.map((representative, i) => {
                    return {
                        ssn: representative.ssn,
                        givenName: representative.firstName ? representative.firstName : userData.givenName,
                        familyName: representative.lastName ? representative.lastName : userData.familyName,
                        title: representative.title,
                        phone: representativeDetails.repPhoneNumber ? `+1${representativeDetails.repPhoneNumber}` : affilateInfo.phoneNumber,
                        email: representativeDetails.email ? representativeDetails.email : affilateInfo.email,
                        kycAddressProofUrl: representative.kycAddressProofUrl || null,
                        address: {
                            city: representative.city || bussinessAddress[0].city,
                            countryCode: 'US',
                            deleted: true,
                            postalCode: representative.zipCode || bussinessAddress[0].zipCode,
                            state: representative.state || bussinessAddress[0].state,
                            street: representative.streetAddress || bussinessAddress[0].streetAddress,
                        },
                        dateofbirth: getDateofBirth(representative.year, representative.month, representative.day),
                        hasControl: representative.hasControl,
                        ownerShipPercentage: representative.ownerShipPercentage,
                        governmentIdUrl: representative.governmentIdUrl || null,
                    };
                });
            } else {
                representativeInfo = representativeDetails.map((representative, i) => {
                    return {
                        pan: representative.pan || '',
                        givenName: representative.firstName ? representative.firstName : userData.givenName,
                        familyName: representative.lastName ? representative.lastName : userData.familyName,
                        title: representative.title,
                        phone: representativeDetails.repPhoneNumber ? `+91${representativeDetails.repPhoneNumber}` : affilateInfo.phoneNumber,
                        email: representativeDetails.email ? representativeDetails.email : affilateInfo.email,
                        kycAddressProofUrl: representative.kycAddressProofUrl || null,
                        businessRepPanUrl: representative.businessRepPanUrl || null,
                        address: {
                            city: representative.city || bussinessAddress[0].city,
                            countryCode: 'IN',
                            deleted: true,
                            postalCode: representative.zipCode || bussinessAddress[0].zipCode,
                            state: representative.state || bussinessAddress[0].state,
                            street: representative.streetAddress || bussinessAddress[0].streetAddress,
                        },
                        dateofbirth: getDateofBirth(representative.year, representative.month, representative.day),
                        hasControl: representative.hasControl,
                    };
                });
            }

            if (bussinessDetails[0].country === 'IN') {
                params = {
                    account: {
                        name: bussinessDetails[0].accountName || affilateInfo.name,
                        countryCode: 'IN',
                        contactEmail: affilateInfo.email,
                        contactFamilyName: userData.familyName,
                        contactGivenName: userData.givenName,
                        contactNumber: affilateInfo.phoneNumber,
                        timezone: 'Asia/Kolkata',
                        affiliateCode: affilateInfo.affiliateCode
                    },
                    inBusiness: {
                        name: bussinessDetails[0].name,
                        url: bussinessDetails[0].website,
                        shortenedDescriptor: payoutDetails[0].accountHolderName || accntName,
                        statementDescriptor: bussinessDetails[0].statementDescriptor || accntName,
                        address: {
                            city: bussinessAddress[0].city,
                            countryCode: 'IN',
                            deleted: true,
                            postalCode: bussinessAddress[0].zipCode,
                            state: bussinessAddress[0].state,
                            street: bussinessAddress[0].streetAddress
                        },
                        type: bussinessDetails[0].bussinessType,
                        bankName: payoutDetails[0].bankName || bankName,
                        bankIfscCode: payoutDetails[0].bankRoutingNumber || routeNumber,
                        bankAccountNumber: payoutDetails[0].accountNumber || accntNumber,
                        bankBeneficiaryName: payoutDetails[0].accountHolderName || accntName,
                        businessPan: bussinessDetails[0].businessPan,
                        kycBankStatementUrl: bussinessDetails[0].kycBankStatementUrl,
                        kycCompanyPanUrl: bussinessDetails[0].kycCompanyPanUrl,
                        kycRegistrationProofUrl: bussinessDetails[0].kycRegistrationProofUrl,
                        currentAddressProofUrl: bussinessDetails[0].currentAddressProofUrl,
                        boardResolutionUrl: bussinessDetails[0].boardResolutionUrl,
                        gstCertificateUrl: bussinessDetails[0].gstCertificateUrl,
                        eightyGAndTwelveACertificate: bussinessDetails[0].bussinessType !== 'NONPROFIT_ORGANIZATION' ? null : bussinessDetails[0].eightyGAndTwelveACertificate,
                    },
                    inBusinessReps: representativeInfo,
                };
            } else if (bussinessDetails[0].country === 'USA') {
                params = {
                    account: {
                        name: bussinessDetails[0].accountName || affilateInfo.name,
                        countryCode: 'US',
                        contactEmail: affilateInfo.email,
                        contactFamilyName: userData.familyName,
                        contactGivenName: userData.givenName,
                        contactNumber: affilateInfo.phoneNumber,
                        timezone: 'America/Los_Angeles',
                        affiliateCode: affilateInfo.affiliateCode,
                        selectedProducts: products,
                    },
                    usBusiness: {
                        name: bussinessDetails[0].name,
                        url: bussinessDetails[0].website,
                        shortenedDescriptor: payoutDetails[0].accountHolderName || accntName,
                        statementDescriptor: bussinessDetails[0].statementDescriptor || accntName,
                        address: {
                            city: bussinessAddress[0].city,
                            countryCode: 'US',
                            deleted: true,
                            postalCode: bussinessAddress[0].zipCode,
                            state: bussinessAddress[0].state,
                            street: bussinessAddress[0].streetAddress
                        },
                        type: bussinessDetails[0].bussinessType,
                        ein: bussinessDetails[0].employerIdNumber,
                        bankName: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].bankName) : null,
                        bankRoutingNumber: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].bankRoutingNumber) : null,
                        bankAccountNumber: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].accountNumber) : null,
                        bankBeneficiaryName: payoutDetails[0].existingBankType === 'MANUAL' ? returnNullIfEmpty(payoutDetails[0].accountHolderName) : null,
                        averageMonthlyVolume: payoutDetails[0].averageMonthlyVolume ? parseFloat(payoutDetails[0].averageMonthlyVolume) * 100 : 0,
                        averageTicketAmount: payoutDetails[0].averageTicketAmount ? parseFloat(payoutDetails[0].averageTicketAmount) * 100 : 0,
                        modeOfTransactionOnline: returnNullIfEmpty(payoutDetails[0].modeOfTransactionOnline) ? payoutDetails[0].modeOfTransactionOnline.replace('%', '') : null,
                        modeOfTransactionPerson: returnNullIfEmpty(payoutDetails[0].modeOfTransactionPerson) ? payoutDetails[0].modeOfTransactionPerson.replace('%', '') : null,
                        isEbt: payoutDetails[0].isEbt,
                        servicesDeliveredIn: returnNullIfEmpty(payoutDetails[0].servicesDeliveredIn),
                        seasonalBusiness: payoutDetails[0].seasonalBusiness === "true" ? true : false,
                        refundPolicy: returnNullIfEmpty(payoutDetails[0].refundPolicy),
                        whenIsCardCharged: returnNullIfEmpty(payoutDetails[0].whenIsCardCharged),
                        isServiceDateFlexible: payoutDetails[0].isServiceDateFlexible === "true" ? true : payoutDetails[0].isServiceDateFlexible === "false" ? false : null,
                        requestedServiceDate: (payoutDetails[0].serviceyear && payoutDetails[0].servicemonth && payoutDetails[0].serviceday) ? getDateofBirth(payoutDetails[0].serviceyear, payoutDetails[0].servicemonth, payoutDetails[0].serviceday) : null,
                        isTaxExemptOrganisation: bussinessDetails[0].isTaxExemptOrganisation === "Yes" ? true : bussinessDetails[0].isTaxExemptOrganisation === "No" ? false : null,
                        businessPhoneNumber: bussinessDetails[0].phoneNumber ? `+1${bussinessDetails[0].phoneNumber}` : affilateInfo.phoneNumber,
                        voidCheckUrl: payoutDetails[0].voidCheckUrl || null,
                        companyStartDate: (bussinessDetails[0].companyyear && bussinessDetails[0].companymonth !== undefined && bussinessDetails[0].companyday)
                            ? getDateofBirth(bussinessDetails[0].companyyear, bussinessDetails[0].companymonth, bussinessDetails[0].companyday) : null,
                        plaidPublicToken: payoutDetails[0].bankType === 'ISSUER_BANK' && payoutDetails[0].existingBankType === 'PLAID' && !payoutDetails[0].externalAuth && payoutDetails[0].plaidPublicToken ? payoutDetails[0].plaidPublicToken : null,
                        externalAuth: payoutDetails[0].bankType === 'ISSUER_BANK' && payoutDetails[0].existingBankType === 'PLAID' && !payoutDetails[0].plaidPublicToken && payoutDetails[0].externalAuth ? payoutDetails[0].externalAuth : null,
                    },
                    usBusinessReps: representativeInfo,
                };
            };
            if (bussinessDetails[0].bussinessType === 'LIMITED_LIABILITY_PARTNERSHIP' && bussinessDetails[0].country === 'IN') {
                params.inBusiness.llpin = payoutDetails[0].employerIdNumber;
            } else if (bussinessDetails[0].bussinessType !== 'LIMITED_LIABILITY_PARTNERSHIP' && bussinessDetails[0].bussinessType !== 'PROPRIETORSHIP' && bussinessDetails[0].country === 'IN') {
                params.inBusiness.cin = payoutDetails[0].employerIdNumber;
            }
            if (bussinessDetails[0].gst && bussinessDetails[0].country === 'IN') {
                params.inBusiness.gst = bussinessDetails[0].gst;
            }
            if (bussinessDetails[0].tan && bussinessDetails[0].country === 'IN') {
                params.inBusiness.tan = bussinessDetails[0].tan;
            }
            // this value is fetched from the url search params and set in /connect based component
            const createVirtualAccount = localStorage.getItem('createVirtualAccount');
            if (!params.account) {
                params.account = {};
            }
            if (createVirtualAccount) {
                params.account.createVirtualAccount = createVirtualAccount === 'true';
            } else {
                params.account.createVirtualAccount = false;
            }
            setShowSpinner(true);
            try {
                const { data: { entity } } = await axiosAuthInstance.post(BASE_URLS.CONNECT_ACCOUNT, params);
                if (entity && entity.account) {
                    setTransactionModalOpen(true);
                };
                const { nextActionUrl, gid } = entity.account;
                if (nextActionUrl) {
                    window.location = nextActionUrl;
                    return;
                }
                setTransactionModalOpen(false);
                setTransactionSuccessModalOpen(true);
                setTimeout(function () {
                    if (affilateData?.affiliateRedirectUrl) {
                      window.location = affilateData?.affiliateRedirectUrl;
                    } else if (localStorage.getItem('redirectUrl')) {
                        window.location = `${localStorage.getItem('redirectUrl')}?sp-account-id=${gid}`;
                    } else {
                        window.location = `${SWIREPAY_URL}?sp-account-id=${gid}`;
                    }
                }, 5000);
                localStorage.removeItem('publicKey');
                localStorage.removeItem('affiliateId');
                localStorage.removeItem('createVirtualAccount');
            } catch (reason) {
                setShowErrorMessage(true);
                setErrorMessage(reason?.data?.message || reason?.response?.data?.message || 'Unable to process request. Please try again later');
            } finally {
                setShowSpinner(false);
            }
        }
    };

    const prev = () => {
        setStep(step - 1);
        setShowErrorMessage(false);
    };


    const updateDetails = (value) => {
        setStep(value);
    };

  const onSubmitPolicy = (e, value) => {
    e.preventDefault();
    if (value === 'PROCEED') {
      setPolicyConfirmation(false);
    } else {
      setTimeout(function () {
        window.location = SWIREPAY_URL;
      }, 5000);
      setPolicyConfirmation(false);
      setUnProceed(true);
    }
  };

    const steps = [
        {
         title: 'Business',
        },
        {
         title: 'Rep Info',
        },
        {
         title: 'Address',
        },
        {
         title: 'Payouts',
        },
        {
          title: 'Bank Info'
        },
        {
         title: 'Review',
        },
        {
         title: 'Submit',
        },
    ];

    const stepValue = {
        1: 0,
        2: 1,
        3: 2,
        4: 3,
        5: 4,
        6: 5,
        7: 6
    };

  const customAddBankButtonStyle = {
    borderRadius: '10px',
    width: '100%',
    backgroundColor: '#ffffff',
    borderColor: '#0b64bc',
    borderStyle: 'solid',
    borderWidth: '1px',
    color: '#0b64bc',
    height: '36px',
    margin: '0px',
    fontSize: '15px',
    fontWeight: '600'
  };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            step !== 1 && (
                                <LeftBackButtonText
                                    onClick={() => prev()}
                                >
                                    Back
                                </LeftBackButtonText>
                            )
                        }

                        <H1Text>
                            Configure Payments
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >

                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        {
                            step === 1 ? 'BUSINESS DETAILS' :
                            step === 2 ? 'BUSINESS REPRESENTATIVE' :
                            step === 3 ? 'BUSINESS ADDRESS' :
                            step === 4 ? 'PAYOUT DETAILS' :
                            step === 5 ? 'BANK DETAILS' :
                            step === 6 ? 'REVIEW YOUR DETAILS' :
                            'SUBMIT'
                        }

                    </H1Text>
                    <Steps current={stepValue[step]} className="mb-4" style={{ width: '94%' }}>
                        {steps.map(item => (
                        <Steps.Step
                            key={item.title}
                            title={(
                            <span style={{ fontSize: '12.5px', fontWeight: 600 }}>
                                {item.title}
                            </span>
                            )}
                        />
                        ))}
                    </Steps>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            {
                                step === 1 && (
                                    <>
                                        {bussinessDetails.map((item, i) => (
                                            <>
                                                <LabelText className="mb-1">
                                                    Country
                                                </LabelText>
                                                <SelectBox
                                                    defaultValue={item.country || 'Select country'}
                                                    onChange={(e) => {
                                                        const list = [...bussinessDetails];
                                                        list[i].country = e.target.value;
                                                        if (e.target.value === 'USA') {
                                                            setBusinessTypes(BUSINESS_TYPES.US);
                                                            setRepresentativeDetails(BUSINESS_REPRESENTATIVES.US_REPRESENTATIVES);
                                                            setStateList(USA_STATES);
                                                            setZipLabel('Zip code');
                                                            if (isTest === 'test') {
                                                                setRouteNumber('122105155');
                                                            }
                                                        } else if (e.target.value === 'IN') {
                                                            setBusinessTypes(BUSINESS_TYPES.IN);
                                                            setRepresentativeDetails(BUSINESS_REPRESENTATIVES.IN_REPRESENTATIVES);
                                                            setStateList(INDIAN_STATES);
                                                            if (isTest === 'test') {
                                                                setRouteNumber('ICIC0002999');
                                                            }
                                                            setZipLabel('Pin code');
                                                        }
                                                        setBussinessDetails(list);
                                                    }}
                                                >
                                                    {
                                                        !item.country && (
                                                            <option>Select a country</option>)
                                                    }
                                                    {
                                                        countryName === 'US' ? (
                                                            <option key={1} value="USA">United States</option>
                                                        ) : (
                                                            <option key={2} value="IN">India</option>
                                                        )
                                                    }
                                                </SelectBox>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('Country', bussinessDetails[i].country, 'required')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Account Name
                                                </LabelText>
                                                <Input
                                                    placeholder="Enter your account name"
                                                    value={item.accountName}
                                                    onChange={(e) => {
                                                        const list = [...bussinessDetails];
                                                        list[i].accountName = e.currentTarget.value;
                                                        setBussinessDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="2px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('name', bussinessDetails[i].accountName, 'required|validName')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Business Name
                                                </LabelText>
                                                <Input
                                                    placeholder="Enter your business name"
                                                    value={item.name}
                                                    onChange={(e) => {
                                                        const list = [...bussinessDetails];
                                                        list[i].name = e.currentTarget.value;
                                                        setBussinessDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="2px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('name', bussinessDetails[i].name, 'required|validName')}
                                                </Text>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="2px">
                                                    If applicable please provide a business name <br />matching the one listed in IRS documents
                                                </Text>

                                                <LabelText className="mb-1">
                                                    Business Website
                                                </LabelText>
                                                <Input
                                                    placeholder="Business Website"
                                                    value={item.website}
                                                    onChange={(e) => {
                                                        const list = [...bussinessDetails];
                                                        list[i].website = e.currentTarget.value;
                                                        setBussinessDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('Business Website', bussinessDetails[i].website, 'required|validUrl')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Business Type
                                                </LabelText>
                                                <SelectBox
                                                    value={item.bussinessType || 'Select business type'}
                                                    onChange={(e) => {
                                                        const list = [...bussinessDetails];
                                                        list[i].bussinessType = e.target.value;
                                                        setBussinessDetails(list);
                                                    }}
                                                >
                                                    <option>Select a business type</option>
                                                    {
                                                        bussinessTypes.map((item) => (
                                                            <option key={item.key} value={item.value}>{item.display}</option>
                                                        ))
                                                    }
                                                </SelectBox>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('Business Type', bussinessDetails[i].bussinessType, 'required')}
                                                </Text>

                                                {

                                                    bussinessDetails[0].country !== 'IN' && (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                Company Start Date
                                                            </LabelText>
                                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                                <DatePicker
                                                                    value={
                                                                        item.companyyear && item.companymonth !== undefined && item.companyday
                                                                        ? dayjs(`${item.companyyear}-${item.companymonth + 1}-${item.companyday}`, 'YYYY-M-D')
                                                                        : null
                                                                    }
                                                                    onChange={(date) => {
                                                                        if (date) {
                                                                          const list = [...bussinessDetails];
                                                                          list[i].companyyear = date.year();
                                                                          list[i].companymonth = date.month();
                                                                          list[i].companyday = date.date();
                                                                          setBussinessDetails(list);
                                                                        }
                                                                    }}
                                                                    format="DD-MM-YYYY"
                                                                    placeholder="Select date"
                                                                    style={{ width: 200 }}
                                                                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                                                                />
                                                            </div>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Month', bussinessDetails[i].companymonth, 'required')}
                                                            </Text>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Day', bussinessDetails[i].companyday, 'required')}
                                                            </Text>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('year', bussinessDetails[i].companyyear, 'required')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                EIN No. {(bussinessDetails[0].bussinessType === 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP') || (bussinessDetails[0].bussinessType === 'LIMITED_LIABILITY_COMPANY') ? '(optional)' : ''}
                                                            </LabelText>
                                                            <Input
                                                                placeholder="Enter EIN No"
                                                                value={item.employerIdNumber}
                                                                onChange={(e) => {
                                                                    const list = [...bussinessDetails];
                                                                    list[i].employerIdNumber = e.currentTarget.value;
                                                                    setBussinessDetails(list);
                                                                }}
                                                            />
                                                            {(bussinessDetails[0].bussinessType !== 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP') && (bussinessDetails[0].bussinessType !== 'LIMITED_LIABILITY_COMPANY')
                                                                ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {simpleValidator.current.message('Employer Id Number', bussinessDetails[i].employerIdNumber, 'required|EIN')}
                                                                    </Text>
                                                                ) : (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {simpleValidator.current.message('Employer Id Number', bussinessDetails[i].employerIdNumber, 'EIN')}
                                                                    </Text>
                                                                )}
                                                            <LabelText className="mb-1">
                                                                Business Phone Number
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <div className="form-group" style={{ width: '90px', }}>
                                                                    <SelectBox
                                                                        className="form-control"
                                                                        style={{
                                                                            width: '90px',
                                                                            height: '36px',
                                                                            border: '1px solid #C4C4C4',
                                                                            borderRadius: '6px',
                                                                        }}
                                                                        disabled
                                                                    >
                                                                        <option key={item} value="+1">+1</option>
                                                                    </SelectBox>
                                                                </div>
                                                                <div>
                                                                    <Input
                                                                        style={{
                                                                            width: '208px',
                                                                            height: '36px',
                                                                            border: '1px solid #C4C4C4',
                                                                            borderRadius: '6px',
                                                                        }}
                                                                        value={item.phoneNumber}
                                                                        type="tel"
                                                                        onChange={(e) => {
                                                                            const numericValue = e.currentTarget.value.replace(/\D/g, '');
                                                                            const list = [...bussinessDetails];
                                                                            list[i].phoneNumber = numericValue;
                                                                            setBussinessDetails(list);
                                                                        }}
                                                                    />
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {simpleValidator.current.message('phone number', item.phoneNumber, `required|phoneNumValidation:+1${item.phoneNumber}`)}
                                                                    </Text>

                                                                </div>
                                                            </div>
                                                            <LabelText className="mt-1">
                                                                Statement Descriptor
                                                            </LabelText>
                                                            <Input
                                                                placeholder="Statement Descriptor"
                                                                value={item.statementDescriptor}
                                                                onChange={(e) => {
                                                                    const list = [...bussinessDetails];
                                                                    list[i].statementDescriptor = e.currentTarget.value;
                                                                    setBussinessDetails(list);
                                                                }}
                                                            />
                                                            <Text fontSize="12px" marginTop="2px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('statement descriptor', bussinessDetails[i].statementDescriptor, 'required|descriptor')}
                                                            </Text>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="4px">
                                                                This business name show up on your customer's <br />statements. Choose something they will recognize <br />to help prevent disputes.
                                                            </Text>
                                                            <LabelText className="mt-2 mb-2">
                                                                Is Business Tax Exempted Organisation (optional)
                                                            </LabelText>
                                                            <SelectBox
                                                                className="mb-2"
                                                                value={item.isTaxExemptOrganisation}
                                                                onChange={(e) => {
                                                                    const list = [...bussinessDetails];
                                                                    list[i].isTaxExemptOrganisation = e.target.value;
                                                                    setBussinessDetails(list);
                                                                }}
                                                            >
                                                                <option value={null} />
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </SelectBox>
                                                            <div className="mb-4">
                                                            <div className="mb-2 d-flex flex-column align-items-start justify-content-start">
                                                                <LabelText className="mt-2 mb-2">
                                                                    Which products are you interested in?
                                                                </LabelText>
                                                                <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                                                                    (Select all that apply)
                                                                </div>
                                                            </div>
                                                            <Checkbox.Group
                                                              style={{ width: '100%' }}
                                                              onChange={(e) => setProducts(e)}
                                                              value={products}
                                                            >
                                                              <Row gutter={[12, 12]}>
                                                                {PRODUCT_OPTIONS.map((option) => (
                                                                  <Col span={11} key={option.value}>
                                                                    <ProductCard isMobile={isMobileView}>
                                                                      <Checkbox value={option.value}>
                                                                        {option.label}
                                                                      </Checkbox>
                                                                    </ProductCard>
                                                                  </Col>
                                                                ))}
                                                              </Row>
                                                            </Checkbox.Group>
                                                            <Text fontSize="12px" marginTop="2px" marginBottom="0px" color="#ff1e1e">
                                                              {simpleValidator.current.message('products', products, 'required|productRequired')}
                                                            </Text>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {
                                                    bussinessDetails[0].country === 'IN' && (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                Business PAN
                                                            </LabelText>
                                                            <Input
                                                                placeholder="Business PAN"
                                                                value={item.businessPan}
                                                                onChange={(e) => {
                                                                    const list = [...bussinessDetails];
                                                                    list[i].businessPan = e.currentTarget.value;
                                                                    setBussinessDetails(list);
                                                                }}
                                                            />
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Business PAN', bussinessDetails[i].businessPan, 'required|validPAN', { messages: { required: 'The PAN field is required' } })}
                                                            </Text>
                                                            <LabelText className="mt-1">
                                                                Statement Descriptor
                                                            </LabelText>
                                                            <Input
                                                                placeholder="Statement Descriptor"
                                                                value={item.statementDescriptor}
                                                                onChange={(e) => {
                                                                    const list = [...bussinessDetails];
                                                                    list[i].statementDescriptor = e.currentTarget.value;
                                                                    setBussinessDetails(list);
                                                                }}
                                                            />
                                                            <Text fontSize="12px" marginTop="2px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('statement descriptor', bussinessDetails[i].statementDescriptor, 'required|descriptor')}
                                                            </Text>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="4px">
                                                                This business name show up on your customer's <br />statements. Choose something they will recognize <br />to help prevent disputes.
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                GST (optional)
                                                            </LabelText>
                                                            <Input
                                                                placeholder="GST"
                                                                value={item.gst}
                                                                onChange={(e) => {
                                                                    const list = [...bussinessDetails];
                                                                    list[i].gst = e.currentTarget.value;
                                                                    setBussinessDetails(list);
                                                                }}
                                                            />
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {bussinessDetails[0].gst && simpleValidator.current.message('gst', bussinessDetails[0].gst, 'required|validGST')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                TAN (optional)
                                                            </LabelText>
                                                            <Input
                                                                placeholder="TAN"
                                                                value={item.tan}
                                                                onChange={(e) => {
                                                                    const list = [...bussinessDetails];
                                                                    list[i].tan = e.currentTarget.value;
                                                                    setBussinessDetails(list);
                                                                }}
                                                            />
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {bussinessDetails[0].tan && simpleValidator.current.message('tan', bussinessDetails[0].tan, 'required|validTAN', { messages: { required: 'The TAN field is required' } })}
                                                            </Text>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {fileValidate}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Bank Account Statement
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'kycBankStatementUrl', i) }} />
                                                                {bussinessDetails[0].kycBankStatementUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>{kycBankStatement}</label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Bank Account Statement', bussinessDetails[0].kycBankStatementUrl, 'required')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Business Registration Proof
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'kycRegistrationProofUrl', i) }} />
                                                                {bussinessDetails[0].kycRegistrationProofUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>{kycRegistrationProof}</label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Business Registration Proof', bussinessDetails[0].kycRegistrationProofUrl, 'required')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Business PAN Proof
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'kycCompanyPanUrl', i) }} />
                                                                {bussinessDetails[0].kycCompanyPanUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>{kycCompanyPan}</label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Business PAN Proof', bussinessDetails[0].kycCompanyPanUrl, 'required', { messages: { required: 'The Business PAN Proof field is required' } })}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Current Address Proof
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'currentAddress', i) }} />
                                                                {bussinessDetails[0].currentAddressProofUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>{currentAddress}</label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Current Address Proof', bussinessDetails[0].currentAddressProofUrl, 'required', { messages: { required: 'The Current Address Proof field is required' } })}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Board Resolution
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'boardResolution', i) }} />
                                                                {bussinessDetails[0].boardResolutionUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>{boardResolution}</label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('Board Resolution Proof', bussinessDetails[0].boardResolutionUrl, 'required', { messages: { required: 'The Board Resolution field is required' } })}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                GST Certificate
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'gstCertificate', i) }} />
                                                                {bussinessDetails[0].gstCertificateUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>{gstCertificate}</label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('GST Certificate', bussinessDetails[0].gstCertificateUrl, 'required', { messages: { required: 'The GST Certificate field is required' } })}
                                                            </Text>
                                                            {
                                                                item.bussinessType === 'NONPROFIT_ORGANIZATION' && (
                                                                    <>
                                                                        <LabelText className="mb-1">
                                                                            80G and 12A Certficate
                                                                        </LabelText>
                                                                        <div className="d-flex">
                                                                            <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'eightyGCertificate', i) }} />
                                                                            {bussinessDetails[0].eightyGAndTwelveACertificate && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                                        </div>
                                                                        <label id="fileLabel" style={{ marginTop: '10px' }}>{eightyGCertificate}</label>
                                                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                            {simpleValidator.current.message('80g and 12a Url', bussinessDetails[0].eightyGAndTwelveACertificate, 'required', { messages: { required: 'The 80G and 12A certificate field is required' } })}
                                                                        </Text>
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                                {!isReview
                                                    && (
                                                        <>
                                                            <div style={{ paddingTop: '8px' }}>
                                                                <SubmitButton
                                                                    style={{ width: '292px' }}
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    onClick={() => next()}
                                                                    disabled={errorMessage}
                                                                >NEXT <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                            </div>
                                                            <div style={{ paddingTop: '8px' }}>
                                                                <CancelButton
                                                                    style={{ width: '292px' }}
                                                                    marginTop="0px !importnat"
                                                                    onClick={() => saveAsDraft()}
                                                                >SAVE AS DRAFT</CancelButton>
                                                            </div>
                                                            <div>
                                                                {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {isReview
                                                    && (
                                                        <>
                                                            <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginRight="4px"
                                                                    backgroundColor="#FFFFFF"
                                                                    hoverBackgroundColor="#FFFFFF"
                                                                    color="#40A9FF"
                                                                    style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                    onClick={() => updateDetails(5)}
                                                                >CANCEL</SubmitButton>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginLeft="4px"
                                                                    style={{ width: '142px' }}
                                                                    onClick={() => next()}
                                                                >UPDATE</SubmitButton>
                                                            </div>
                                                            <div style={{ paddingTop: '8px' }}>
                                                                <CancelButton
                                                                    style={{ width: '292px' }}
                                                                    marginTop="0px !importnat"
                                                                    onClick={() => saveAsDraft()}
                                                                >SAVE AS DRAFT</CancelButton>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        ))
                                        }
                                    </>
                                )
                            }
                        </FlexContainer>
                    </div>
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            {
                                step === 2 && (
                                    <>
                                        {representativeDetails.map((item, i) => (
                                            <>
                                                <div className="row mt-3 mb-3 mr-2" display="flex">
                                                    <LabelText fontSize="16px">
                                                        REPRESENTATIVE DETAILS
                                                    </LabelText>
                                                    {
                                                        (representativeDetails.length > 1) && (
                                                            <Button
                                                                type="secondary"
                                                                border="2px solid #40A9FF !important"
                                                                color="#40A9FF !important"
                                                                paddingRight="1.5rem"
                                                                paddingTop=".4rem"
                                                                paddingBottom=".4rem"
                                                                borderRadius="50px"
                                                                paddingLeft="1.5rem"
                                                                marginLeft="10px"
                                                                marginTop="5px"
                                                                onClick={() => removeRepresntative(i)}
                                                            >Remove</Button>
                                                        )
                                                    }
                                                </div>
                                                <LabelText className="mb-1">
                                                    First Name
                                                </LabelText>
                                                <Input
                                                    placeholder="First Name"
                                                    defaultValue={representativeDetails[i].firstName}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].firstName = e.currentTarget.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('First Name', representativeDetails[i].firstName, 'required|alpha_space')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Last Name
                                                </LabelText>
                                                <Input
                                                    placeholder="Last Name"
                                                    defaultValue={representativeDetails[i].lastName}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].lastName = e.currentTarget.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('last Name', representativeDetails[i].lastName, 'required|alpha_space')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Email
                                                </LabelText>
                                                <Input
                                                    placeholder="Email"
                                                    defaultValue={representativeDetails[i].email}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].email = e.currentTarget.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('email', representativeDetails[i].email, 'required|email|checkLowerCase')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Phone Number
                                                </LabelText>
                                                <div className="d-flex">
                                                    <div className="form-group" style={{ width: '90px', }}>
                                                        <SelectBox
                                                            className="form-control"
                                                            style={{
                                                                width: '90px',
                                                                height: '36px',
                                                                border: '1px solid #C4C4C4',
                                                                borderRadius: '6px',
                                                            }}
                                                            disabled
                                                        >
                                                            {
                                                                bussinessDetails[0].country === 'IN' ? (
                                                                    <option key={item} value="+91">+91</option>
                                                                ) : (
                                                                    <option key={item} value="+1">+1</option>
                                                                )
                                                            }
                                                        </SelectBox>
                                                    </div>
                                                    <div>
                                                        <Input
                                                            style={{
                                                                width: '208px',
                                                                height: '36px',
                                                                border: '1px solid #C4C4C4',
                                                                borderRadius: '6px',
                                                            }}
                                                            type="tel"
                                                            value={item.repPhoneNumber}
                                                            onChange={(e) => {
                                                                const numericValue = e.currentTarget.value.replace(/\D/g, '');
                                                                const list = [...representativeDetails];
                                                                list[i].repPhoneNumber = numericValue;
                                                                setRepresentativeDetails(list);
                                                            }}
                                                        />
                                                        {
                                                            bussinessDetails[0].country === 'IN' ? (
                                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message('phone number', item.repPhoneNumber, `required|phoneNumValidation:+91${item.repPhoneNumber}`)}
                                                                </Text>
                                                            ) : (
                                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message('phone number', item.repPhoneNumber, `required|phoneNumValidation:+1${item.repPhoneNumber}`)}
                                                                </Text>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                    bussinessDetails[0].country === 'IN' ? (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                PAN
                                                            </LabelText>
                                                            <InputWrapper marginBottom="0px" paddingRight='5px' borderRadius="4px">
                                                                <Input
                                                                    placeholder="Enter PAN"
                                                                    value={item.pan}
                                                                    onChange={(e) => {
                                                                        const list = [...representativeDetails];
                                                                        list[i].pan = e.currentTarget.value;
                                                                        setRepresentativeDetails(list);
                                                                    }}
                                                                    style={{
                                                                        margin: "0px",
                                                                        border: "0px",
                                                                        width: "268px",
                                                                    }}
                                                                    type="text"
                                                                />
                                                            </InputWrapper>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('PAN', representativeDetails[i].pan, 'required|validPAN', { messages: { required: 'The PAN field is required' } })}
                                                            </Text>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                SSN
                                                            </LabelText>
                                                            <InputWrapper marginBottom="0px" paddingRight='5px' borderRadius="4px">
                                                                <Input
                                                                    placeholder="Enter SSN"
                                                                    maxLength={9}
                                                                    autoComplete="new-password"
                                                                    value={item.ssn}
                                                                    onChange={(e) => {
                                                                        const list = [...representativeDetails];
                                                                        list[i].ssn = e.currentTarget.value;
                                                                        setRepresentativeDetails(list);
                                                                    }}
                                                                    style={{
                                                                        margin: "0px",
                                                                        border: "0px",
                                                                        width: "268px",
                                                                    }}
                                                                    type={showPassword ? "text" : "password"}
                                                                />
                                                                <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                                                            </InputWrapper>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('ssn', representativeDetails[i].ssn, 'required|validSSN')}
                                                            </Text>
                                                        </>
                                                    )
                                                }

                                                <LabelText className="mb-1">
                                                    Title
                                                </LabelText>
                                                <Input
                                                    placeholder="Enter Title"
                                                    value={item.title}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].title = e.currentTarget.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('title', representativeDetails[i].title, 'required|alpha')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Legal Address of the Representative
                                                </LabelText>
                                                <Input
                                                    placeholder="Enter street address"
                                                    value={item.streetAddress}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].streetAddress = e.currentTarget.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('street Address', representativeDetails[i].streetAddress, 'required')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    City
                                                </LabelText>
                                                <Input
                                                    placeholder="Enter city"
                                                    value={item.city}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].city = e.currentTarget.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('city', representativeDetails[i].city, 'required')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    State
                                                </LabelText>
                                                <SelectBox
                                                    value={item.state}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].state = e.target.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                >
                                                    <option>Select a State</option>
                                                    {stateList.map((item) => (
                                                        <option value={item.code}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </SelectBox>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('state', representativeDetails[i].state, 'required')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    {zipLabel}
                                                </LabelText>
                                                <Input
                                                    placeholder={`Enter ${zipLabel}`}
                                                    value={item.zipCode}
                                                    maxLength={bussinessDetails[0].country === 'IN' ? 6 : 5}
                                                    onChange={(e) => {
                                                        const list = [...representativeDetails];
                                                        list[i].zipCode = e.currentTarget.value;
                                                        setRepresentativeDetails(list);
                                                    }}
                                                    onKeyPress={e => {
                                                        const keyCode = e.charCode || e.which;
                                                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message(zipLabel, representativeDetails[i].zipCode, 'required|numeric')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    Country
                                                </LabelText>
                                                <SelectBox
                                                    disabled
                                                    style={{
                                                        background: '#e9ecef',
                                                    }}
                                                >
                                                    {
                                                        bussinessDetails[0].country === 'IN' ? (
                                                            <option key={2} value="IN">India</option>
                                                        ) : (
                                                            <option key={1} value="USA">United States</option>
                                                        )
                                                    }
                                                </SelectBox>
                                                <LabelText className="mb-1">
                                                    Date of Birth
                                                </LabelText>
                                                <div>
                                                    <DatePicker
                                                        value={
                                                            item.year && item.month !== undefined && item.day
                                                            ? dayjs(`${item.year}-${item.month + 1}-${item.day}`, 'YYYY-M-D')
                                                            : null
                                                        }
                                                        onChange={(date) => {
                                                            if (date) {
                                                            const list = [...representativeDetails];
                                                            list[i].year = date.year();
                                                            list[i].month = date.month();
                                                            list[i].day = date.date();
                                                            setRepresentativeDetails(list);
                                                            }
                                                        }}
                                                        format="DD-MM-YYYY"
                                                        placeholder="Select date"
                                                        style={{ width: 200 }}
                                                        disabledDate={(current) => (
                                                            current && (current.isAfter(dayjs(), 'day') || current.year() < 1950)
                                                        )}
                                                    />
                                                </div>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('Month', representativeDetails[i].month, 'required')}
                                                </Text>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('Day', representativeDetails[i].day, 'required')}
                                                </Text>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('year', representativeDetails[i].year, 'required')}
                                                </Text>
                                                {
                                                    countryName === 'IN' ? (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                Id Proof
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'kycAddressProofUrl', i) }} />
                                                                {representativeDetails[i].kycAddressProofUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>
                                                                {i === 0 ? kycAddressProofUrl1 : i === 1 ? kycAddressProofUrl2 : i === 2 ? kycAddressProofUrl3 : kycAddressProofUrl4}
                                                            </label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('address Proof', representativeDetails[i].kycAddressProofUrl, 'required')}
                                                            </Text>
                                                            {
                                                                i === 0 && idProofFileError1 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {idProofFileError1}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                            {
                                                                i === 1 && idProofFileError2 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {idProofFileError2}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                            {
                                                                i === 2 && idProofFileError3 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {idProofFileError3}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                            {
                                                                i === 3 && idProofFileError4 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {idProofFileError4}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                            <LabelText className="mb-1">
                                                                PAN Proof
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'panProofUrl', i) }} />
                                                                {representativeDetails[i].businessRepPanUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>
                                                                {representativeDetails[i].panfileName}
                                                                {i === 0 ? panProofUrl1 : i === 1 ? panProofUrl2 : i === 2 ? panProofUrl3 : panProofUrl4}
                                                            </label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('pan proof', representativeDetails[i].businessRepPanUrl, 'required')}
                                                            </Text>
                                                            {
                                                                i === 0 && panProofFileError1 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {panProofFileError1}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                            {
                                                                i === 1 && panProofFileError2 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {panProofFileError2}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                            {
                                                                i === 2 && panProofFileError3 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {panProofFileError3}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                            {
                                                                i === 3 && panProofFileError4 ? (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {panProofFileError4}
                                                                    </Text>
                                                                ) : null
                                                            }
                                                        </>
                                                    ) : null
                                                }
                                                {
                                                    countryName !== 'IN' ? (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                Percentage Ownership
                                                            </LabelText>
                                                            <div>
                                                                <Input
                                                                    placeholder="Percentage Ownership"
                                                                    value={representativeDetails[i].ownerShipPercentage}
                                                                    style={{
                                                                        borderRadius: '4px 0px 0px 4px',
                                                                        width: '278px',
                                                                        borderRight: '1px solid transparent',
                                                                    }}
                                                                    onChange={(e) => {
                                                                        const list = [...representativeDetails];
                                                                        list[i].ownerShipPercentage = e.currentTarget.value;
                                                                        if (e.currentTarget.value && e.currentTarget.value >= 25) {
                                                                            list[i].hasControl = true;
                                                                        } else {
                                                                            list[i].hasControl = false;
                                                                        }
                                                                        setRepresentativeDetails(list);
                                                                    }}
                                                                />
                                                                <Input
                                                                    style={{
                                                                        borderRadius: '0px 4px 4px 0px',
                                                                        width: '20px',
                                                                        borderLeft: '1px solid transparent',
                                                                    }}
                                                                    value={'%'}
                                                                />
                                                            </div>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('percentage ownership', representativeDetails[i].ownerShipPercentage, 'required|ownerShip')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Govt. ID (Driver License, Passport etc.)
                                                            </LabelText>
                                                            <div className="d-flex">
                                                                <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'governmentIdUrl', i) }} />
                                                                {representativeDetails[i].governmentIdUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                            </div>
                                                            <label id="fileLabel" style={{ marginTop: '10px' }}>
                                                                {i === 0 ? govtAddressProofUrl1 : i === 1 ? govtAddressProofUrl2 : i === 2 ? govtAddressProofUrl3 : govtAddressProofUrl4}
                                                            </label>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('govt id proof', representativeDetails[i].governmentIdUrl, 'required')}
                                                            </Text>
                                                        </>
                                                    ) : null
                                                }
                                                {
                                                    bussinessDetails[0].country === 'IN' && (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                Do you own more than 25% of this business, or exercise significant control?
                                                            </LabelText>
                                                            <div style={{ textAlign: 'left', marginTop: '10px' }}>
                                                                <input
                                                                    type="radio"
                                                                    style={{ width: "30px", height: "15px", verticalAlign: "middle" }}
                                                                    name={representativeDetails[i].hasControl}
                                                                    checked={(representativeDetails[i].hasControl) === true ? true : false}
                                                                    value="true"
                                                                    onChange={(e) => {
                                                                        const list = [...representativeDetails];
                                                                        list[i].hasControl = true;
                                                                        setRepresentativeDetails(list);
                                                                    }}
                                                                />
                                                                <span>Yes</span>
                                                                <input
                                                                    type="radio"
                                                                    name={representativeDetails[i].hasControl}
                                                                    value="false"
                                                                    style={{ width: "30px", height: "15px", verticalAlign: "middle" }}
                                                                    checked={(representativeDetails[i].hasControl) === false ? true : false}
                                                                    onChange={(e) => {
                                                                        const list = [...representativeDetails];
                                                                        list[i].hasControl = false;
                                                                        setRepresentativeDetails(list);
                                                                    }}
                                                                />
                                                                <span>No</span>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                <Hr />
                                            </>
                                        ))
                                        }
                                        {
                                            controlError && (
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {controlError}
                                                </Text>
                                            )
                                        }
                                        {
                                            ((representativeDetails.length <= 3)) && (
                                                <>
                                                    <div style={{ marginBottom: '10px', marginTop: '10px' }}>
                                                        <SubmitButton
                                                            type="submit"
                                                            backgroundColor="#FFFFFF"
                                                            hoverBackgroundColor="#FFFFFF"
                                                            color="#40A9FF"
                                                            onClick={() => addAnotherRepresntative()}
                                                            style={{ marginLeft: '10px', marginTop: '10px', marginBottom: '10px', border: '1px solid #40A9FF' }}
                                                        >Add Representative</SubmitButton>
                                                    </div>
                                                    <Hr />
                                                </>
                                            )
                                        }

                                        <>
                                            {!isReview
                                                && (
                                                    <>
                                                        <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                            <SubmitButton
                                                                type="submit"
                                                                marginTop="0px !importnat"
                                                                marginRight="4px"
                                                                backgroundColor="#FFFFFF"
                                                                hoverBackgroundColor="#FFFFFF"
                                                                color="#40A9FF"
                                                                style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                onClick={() => prev()}
                                                            ><Img verticalAlign='middle' src={BackArrow} /> BACK</SubmitButton>
                                                            <SubmitButton
                                                                type="submit"
                                                                marginTop="0px !importnat"
                                                                marginLeft="4px"
                                                                style={{ width: '142px' }}
                                                                onClick={() => next()}
                                                            >NEXT <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                        </div>
                                                        <div style={{ paddingTop: '8px' }}>
                                                            <CancelButton
                                                                style={{ width: '292px' }}
                                                                marginTop="0px !importnat"
                                                                onClick={() => saveAsDraft()}
                                                            >SAVE AS DRAFT</CancelButton>
                                                        </div>
                                                    </>
                                                )}
                                            {isReview
                                                && (
                                                    <>
                                                        <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                            <SubmitButton
                                                                type="submit"
                                                                marginTop="0px !importnat"
                                                                marginRight="4px"
                                                                backgroundColor="#FFFFFF"
                                                                hoverBackgroundColor="#FFFFFF"
                                                                color="#40A9FF"
                                                                style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                onClick={() => updateDetails(5)}
                                                            >CANCEL</SubmitButton>
                                                            <SubmitButton
                                                                type="submit"
                                                                marginTop="0px !importnat"
                                                                marginLeft="4px"
                                                                style={{ width: '142px' }}
                                                                onClick={() => next()}
                                                            >UPDATE</SubmitButton>
                                                        </div>
                                                        <div style={{ paddingTop: '8px' }}>
                                                            <CancelButton
                                                                style={{ width: '292px' }}
                                                                marginTop="0px !importnat"
                                                                onClick={() => saveAsDraft()}
                                                            >SAVE AS DRAFT</CancelButton>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </>
                                    </>
                                )
                            }
                        </FlexContainer>
                    </div>
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            {
                                step === 3 && (
                                    <>
                                        {bussinessAddress.map((item, i) => (
                                            <>
                                                <LabelText className="mb-1">
                                                    Street Address
                                                </LabelText>
                                                <Input
                                                    placeholder="Enter street address"
                                                    value={item.streetAddress}
                                                    onChange={(e) => {
                                                        const list = [...bussinessAddress];
                                                        list[i].streetAddress = e.currentTarget.value;
                                                        setBussinessAddress(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('street Address', bussinessAddress[i].streetAddress, 'required')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    City
                                                </LabelText>
                                                <Input
                                                    placeholder="Enter city"
                                                    value={item.city}
                                                    onChange={(e) => {
                                                        const list = [...bussinessAddress];
                                                        list[i].city = e.currentTarget.value;
                                                        setBussinessAddress(list);
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('city', bussinessAddress[i].city, 'required')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    State
                                                </LabelText>
                                                <SelectBox
                                                    value={item.state}
                                                    onChange={(e) => {
                                                        const list = [...bussinessAddress];
                                                        list[i].state = e.target.value;
                                                        setBussinessAddress(list);
                                                    }}
                                                >
                                                    <option>Select a State</option>
                                                    {stateList.map((item) => (
                                                        <option value={item.code}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </SelectBox>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('state', bussinessAddress[i].state, 'required')}
                                                </Text>
                                                <LabelText className="mb-1">
                                                    {zipLabel}
                                                </LabelText>
                                                <Input
                                                    placeholder={`Enter ${zipLabel}`}
                                                    value={item.zipCode}
                                                    maxLength={bussinessDetails[0].country === 'IN' ? 6 : 5}
                                                    onChange={(e) => {
                                                        const list = [...bussinessAddress];
                                                        list[i].zipCode = e.currentTarget.value;
                                                        setBussinessAddress(list);
                                                    }}
                                                    onKeyPress={e => {
                                                        const keyCode = e.charCode || e.which;
                                                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message(zipLabel, bussinessAddress[i].zipCode, 'required|numeric')}
                                                </Text>
                                                {!isReview
                                                    && (
                                                        <>
                                                            <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginRight="4px"
                                                                    backgroundColor="#FFFFFF"
                                                                    hoverBackgroundColor="#FFFFFF"
                                                                    color="#40A9FF"
                                                                    style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                    onClick={() => prev()}
                                                                ><Img verticalAlign='middle' src={BackArrow} /> BACK</SubmitButton>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginLeft="4px"
                                                                    style={{ width: '142px' }}
                                                                    onClick={() => next()}
                                                                >NEXT <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                            </div>
                                                            <div style={{ paddingTop: '8px' }}>
                                                                <CancelButton
                                                                    style={{ width: '292px' }}
                                                                    marginTop="0px !importnat"
                                                                    onClick={() => saveAsDraft()}
                                                                >SAVE AS DRAFT</CancelButton>
                                                            </div>
                                                        </>
                                                    )}
                                                {isReview
                                                    && (
                                                        <>
                                                            <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginRight="4px"
                                                                    backgroundColor="#FFFFFF"
                                                                    hoverBackgroundColor="#FFFFFF"
                                                                    color="#40A9FF"
                                                                    style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                    onClick={() => updateDetails(5)}
                                                                >CANCEL</SubmitButton>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginLeft="4px"
                                                                    style={{ width: '142px' }}
                                                                    onClick={() => next()}
                                                                >UPDATE</SubmitButton>
                                                            </div>
                                                            <div style={{ paddingTop: '8px' }}>
                                                                <CancelButton
                                                                    style={{ width: '292px' }}
                                                                    marginTop="0px !importnat"
                                                                    onClick={() => saveAsDraft()}
                                                                >SAVE AS DRAFT</CancelButton>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        ))
                                        }
                                    </>
                                )
                            }
                        </FlexContainer>
                    </div>
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            {
                                step === 4 && (
                                    <>
                                        {payoutDetails.map((item, i) => (
                                            <>
                                                {
                                                    bussinessDetails[0].country !== 'IN' && isProcessingInfoRequired ? (
                                                        <>
                                                            <LabelText className="mb-1">
                                                                Average Monthly Volume
                                                            </LabelText>
                                                            <div>
                                                                <Input
                                                                    style={{
                                                                        borderRadius: '6px 0px 0px 6px',
                                                                        width: '20px',
                                                                        borderRight: '1px solid transparent',
                                                                    }}
                                                                    value={`$`}
                                                                />
                                                                <Input
                                                                    style={{
                                                                        borderRadius: '0px 4px 4px 0px',
                                                                        width: '280px',
                                                                        borderLeft: '1px solid transparent',
                                                                    }}
                                                                    placeholder="Average Monthly Volume"
                                                                    value={item.averageMonthlyVolume}
                                                                    onChange={(e) => {
                                                                        const list = [...payoutDetails];
                                                                        const { value } = e.currentTarget;
                                                                        if (amountRegex.test(value) || value === '') {
                                                                            list[i].averageMonthlyVolume = value;
                                                                            setPayoutDetails(list);
                                                                        } else if (!amountRegex.test(value)) {
                                                                            list[i].averageMonthlyVolume = 0.00;
                                                                            setPayoutDetails(list);
                                                                        }
                                                                    }}
                                                                    onKeyPress={e => {
                                                                        const keyCode = e.charCode || e.which;
                                                                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onBlur={e => {
                                                                        if (e.currentTarget.value) {
                                                                            const list = [...payoutDetails];
                                                                            const amount = parseFloat(e.currentTarget.value);
                                                                            if (Number(amount)) {
                                                                                list[i].averageMonthlyVolume = parseFloat(amount).toFixed(2)
                                                                                setPayoutDetails(list);
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('average monthly volume', payoutDetails[i].averageMonthlyVolume, 'required|numeric|minamount|maxamount')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Average Ticket Amount
                                                            </LabelText>
                                                            <div>
                                                                <Input
                                                                    style={{
                                                                        borderRadius: '4px 0px 0px 4px',
                                                                        width: '20px',
                                                                        borderRight: '1px solid transparent',
                                                                    }}
                                                                    value={`$`}
                                                                />
                                                                <Input
                                                                    style={{
                                                                        borderRadius: '0px 6px 6px 0px',
                                                                        width: '280px',
                                                                        borderLeft: '1px solid transparent',
                                                                    }}
                                                                    placeholder="Average Ticket Amount"
                                                                    value={item.averageTicketAmount}
                                                                    onChange={(e) => {
                                                                        const list = [...payoutDetails];
                                                                        const { value } = e.currentTarget;
                                                                        if (amountRegex.test(value) || value === '') {
                                                                            list[i].averageTicketAmount = value;
                                                                            setPayoutDetails(list);
                                                                        } else if (!amountRegex.test(value)) {
                                                                            list[i].averageTicketAmount = 0.00;
                                                                            setPayoutDetails(list);
                                                                        }
                                                                    }}
                                                                    onKeyPress={e => {
                                                                        const keyCode = e.charCode || e.which;
                                                                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onBlur={e => {
                                                                        if (e.currentTarget.value) {
                                                                            const list = [...payoutDetails];
                                                                            const amount = parseFloat(e.currentTarget.value);
                                                                            if (Number(amount)) {
                                                                                list[i].averageTicketAmount = parseFloat(amount).toFixed(2)
                                                                                setPayoutDetails(list);
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('average ticket amount', payoutDetails[i].averageTicketAmount, `required|numeric|minamount|maxamount|averageTicketAmountCheck:${item.averageMonthlyVolume}`)}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Do Customers Typically Receive <br />Goods/Services at the Time of Purchase?
                                                            </LabelText>
                                                            <SelectBox
                                                                value={item.whenIsCardCharged}
                                                                onChange={(e) => {
                                                                    const list = [...payoutDetails];
                                                                    list[i].whenIsCardCharged = e.target.value;
                                                                    setPayoutDetails(list);
                                                                }}
                                                            >
                                                                <option value={null} />
                                                                <option key={1} value="IN_ADVANCE">Yes</option>
                                                                <option key={2} value="WHEN_SERVICE_PROVIDED">No</option>
                                                            </SelectBox>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('when is card charged', payoutDetails[i].whenIsCardCharged, 'required')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                When Are Goods and Services Delivered?
                                                            </LabelText>
                                                            <SelectBox
                                                                value={item.servicesDeliveredIn}
                                                                onChange={(e) => {
                                                                    const list = [...payoutDetails];
                                                                    list[i].servicesDeliveredIn = e.target.value;
                                                                    setPayoutDetails(list);
                                                                }}
                                                            >
                                                                <option value={null} />
                                                                <option key={1} value="ZERO_TO_SEVEN_DAYS">0-7 Days</option>
                                                                <option key={2} value="EIGHT_TO_FOURTEEN_DAYS">8-14 Days</option>
                                                                <option key={3} value="FIFTEEN_TO_THIRTY_DAYS">15-30 Days</option>
                                                                <option key={4} value="OVER_THIRTY_DAYS">Over 30 Days</option>
                                                            </SelectBox>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('services delivered in', payoutDetails[i].servicesDeliveredIn, 'required')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                What is Your Current Refund Policy?
                                                            </LabelText>
                                                            <SelectBox
                                                                value={item.refundPolicy}
                                                                onChange={(e) => {
                                                                    const list = [...payoutDetails];
                                                                    list[i].refundPolicy = e.target.value;
                                                                    setPayoutDetails(list);
                                                                }}
                                                            >
                                                                <option value={null} />
                                                                <option key={1} value="EXCHANGE_ONLY">Exchange Only</option>
                                                                <option key={2} value="NO_REFUND_OR_EXCHANGE">No Refund or Exchange</option>
                                                                <option key={3} value="MORE_THAN_THIRTY_DAYS">More than 30 Days</option>
                                                                <option key={4} value="THIRTY_DAYS_OR_LESS">30 Days or Less</option>
                                                            </SelectBox>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('refund policy', payoutDetails[i].refundPolicy, 'required')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Is Your Business Seasonal or do you Process <br />Payments Throughout the Year?
                                                            </LabelText>
                                                            <SelectBox
                                                                value={item.seasonalBusiness}
                                                                onChange={(e) => {
                                                                    const list = [...payoutDetails];
                                                                    list[i].seasonalBusiness = e.target.value;
                                                                    setPayoutDetails(list);
                                                                }}
                                                            >
                                                                <option value={null} />
                                                                <option key={1} value={true}>Yes</option>
                                                                <option key={2} value={false}>No</option>
                                                            </SelectBox>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('seasonal business', payoutDetails[i].seasonalBusiness, 'required')}
                                                            </Text>
                                                            <LabelText className="mb-1">
                                                                Mode of Transaction In Person
                                                            </LabelText>
                                                            <SelectBox
                                                                value={item.modeOfTransactionPerson}
                                                                onChange={(e) => {
                                                                  const list = [...payoutDetails];
                                                                  const selectedValue = e.target.value;

                                                                  const num = Number(selectedValue.replace('%', ''));

                                                                  list[i].modeOfTransactionPerson = selectedValue;
                                                                  list[i].modeOfTransactionPerson1 = getPersonValue(selectedValue);

                                                                  const remaining = 100 - num;
                                                                  const remainingStr = `${remaining}%`;

                                                                  list[i].modeOfTransactionOnline = remainingStr;
                                                                  list[i].modeOfTransactionOnline1 = getPersonValue(remainingStr);

                                                                  setPayoutDetails(list);
                                                                  setModeTransactionError('');
                                                                }}
                                                            >
                                                                <option value={null} />
                                                                <option key={1} value="0%">0%</option>
                                                                <option key={2} value="25%">25% </option>
                                                                <option key={3} value="50%">50%</option>
                                                                <option key={4} value="75%">75%</option>
                                                                <option key={5} value="100%">100%</option>
                                                            </SelectBox>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('in person', payoutDetails[i].modeOfTransactionPerson, 'required')}
                                                            </Text>
                                                            {
                                                                (item.modeOfTransactionPerson1 > 0) && (
                                                                    <div className="mt-3 ml-1">
                                                                        <label>
                                                                            <Input
                                                                                type="checkbox"
                                                                                checked={item?.isEbt || false}
                                                                                onChange={({ target: { checked } }) => {
                                                                                    const list = [...payoutDetails];
                                                                                    list[i].isEbt = checked;
                                                                                    setPayoutDetails(list);
                                                                                }} width="auto" />
                                                                            <SpanText className="pl-2">Accept Electronic Benefits Transfer (EBT) Payments</SpanText></label>
                                                                    </div>
                                                                )
                                                            }
                                                            <LabelText className="mb-1">
                                                                Mode of Transaction Online
                                                            </LabelText>
                                                            <SelectBox
                                                                value={item.modeOfTransactionOnline}
                                                                onChange={(e) => {
                                                                  const list = [...payoutDetails];
                                                                  const selectedValue = e.target.value;
                                                                  const num = Number(selectedValue.replace('%', ''));

                                                                  list[i].modeOfTransactionOnline = selectedValue;
                                                                  list[i].modeOfTransactionOnline1 = getPersonValue(selectedValue);

                                                                  const remaining = 100 - num;
                                                                  const remainingStr = `${remaining}%`;

                                                                  list[i].modeOfTransactionPerson = remainingStr;
                                                                  list[i].modeOfTransactionPerson1 = getPersonValue(remainingStr);

                                                                  setPayoutDetails(list);
                                                                  setModeTransactionError('');
                                                                }}
                                                            >
                                                                <option value={null} />
                                                                <option key={1} value="0%">0%</option>
                                                                <option key={2} value="25%">25% </option>
                                                                <option key={3} value="50%">50%</option>
                                                                <option key={4} value="75%">75%</option>
                                                                <option key={5} value="100%">100%</option>
                                                            </SelectBox>
                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                {simpleValidator.current.message('transaction online', payoutDetails[i].modeOfTransactionOnline, 'required')}
                                                            </Text>
                                                            {
                                                                modeTransactionError && (
                                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                        {modeTransactionError}
                                                                    </Text>
                                                                )
                                                            }
                                                            {
                                                                (item.modeOfTransactionPerson1 > 0) && (
                                                                    <>
                                                                        <LabelText className="mb-1">
                                                                            Is Service Date Flexible (optional)
                                                                        </LabelText>
                                                                        <SelectBox
                                                                            value={item.isServiceDateFlexible}
                                                                            onChange={(e) => {
                                                                                const list = [...payoutDetails];
                                                                                list[i].isServiceDateFlexible = e.target.value;
                                                                                setPayoutDetails(list);
                                                                            }}
                                                                        >
                                                                            <option value={null} />
                                                                            <option key={1} value={true}>Yes</option>
                                                                            <option key={2} value={false}>No</option>
                                                                        </SelectBox>
                                                                        <LabelText className="mb-1">
                                                                            Requested Service Date (optional)
                                                                        </LabelText>
                                                                        <div>
                                                                            <DatePicker
                                                                                value={
                                                                                    item.serviceyear && item.servicemonth !== undefined && item.serviceday
                                                                                    ? dayjs(`${item.serviceyear}-${item.servicemonth + 1}-${item.serviceday}`, 'YYYY-M-D')
                                                                                    : null
                                                                                }
                                                                                onChange={(date) => {
                                                                                    if (date) {
                                                                                    const list = [...payoutDetails];
                                                                                    list[i].serviceyear = date.year();
                                                                                    list[i].servicemonth = date.month();
                                                                                    list[i].serviceday = date.date();
                                                                                    setPayoutDetails(list);
                                                                                    }
                                                                                }}
                                                                                format="DD-MM-YYYY"
                                                                                placeholder="Select date"
                                                                                style={{ width: 200 }}
                                                                                disabledDate={(current) =>
                                                                                    current && (current.year() < 2023 || current.year() > 2099)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    ) : (
                                                      <Alert
                                                        type="info"
                                                        showIcon
                                                        className="w-100 mb-3"
                                                        message={`You can skip this — it’s not needed for ${bussinessDetails[0].country === 'IN' ? 'Indian accounts' : 'your product'}.`}
                                                      />
                                                    )
                                                }
                                                {!isReview
                                                    && (
                                                        <>
                                                            <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginRight="4px"
                                                                    backgroundColor="#FFFFFF"
                                                                    hoverBackgroundColor="#FFFFFF"
                                                                    color="#40A9FF"
                                                                    style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                    onClick={() => prev()}
                                                                ><Img verticalAlign='middle' src={BackArrow} /> BACK</SubmitButton>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginLeft="4px"
                                                                    style={{ width: '142px' }}
                                                                    onClick={() => next()}
                                                                >NEXT <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                            </div>
                                                            <div style={{ paddingTop: '8px' }}>
                                                                <CancelButton
                                                                    style={{ width: '292px' }}
                                                                    marginTop="0px !importnat"
                                                                    onClick={() => saveAsDraft()}
                                                                >SAVE AS DRAFT</CancelButton>
                                                            </div>
                                                        </>
                                                    )}
                                                {isReview
                                                    && (
                                                        <>
                                                            <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginRight="4px"
                                                                    backgroundColor="#FFFFFF"
                                                                    hoverBackgroundColor="#FFFFFF"
                                                                    color="#40A9FF"
                                                                    style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                    onClick={() => updateDetails(5)}
                                                                >CANCEL</SubmitButton>
                                                                <SubmitButton
                                                                    type="submit"
                                                                    marginTop="0px !importnat"
                                                                    marginLeft="4px"
                                                                    style={{ width: '142px' }}
                                                                    onClick={() => next()}
                                                                >UPDATE</SubmitButton>
                                                            </div>
                                                            <div style={{ paddingTop: '8px' }}>
                                                                <CancelButton
                                                                    style={{ width: '292px' }}
                                                                    marginTop="0px !importnat"
                                                                    onClick={() => saveAsDraft()}
                                                                >SAVE AS DRAFT</CancelButton>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        ))
                                        }
                                    </>
                                )
                            }
                        </FlexContainer>
                    </div>

                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            {
                                step === 5 && (
                                    <>
                                        {payoutDetails.map((item, i) => (
                                            <>
                                              {bussinessDetails[0].country === 'USA' && (
                                                <div>
                                                <LabelText className="mb-1">
                                                    Bank Account Type
                                                </LabelText>
                                                <SelectBox
                                                    value={item.bankType || 'Select bank account type'}
                                                    onChange={(e) => {
                                                        const list = [...payoutDetails];
                                                        if (e.target.value !== 'ISSUER_BANK') {
                                                          list[i].existingBankType = null;
                                                          list[i].plaidPublicToken = null;
                                                        }
                                                        list[i].bankType = e.target.value;
                                                        setPayoutDetails(list);
                                                    }}
                                                >
                                                    <option>Select a account type</option>
                                                    {
                                                        bankAccountType.map((item) => (
                                                            <option key={item.key} value={item.value}>{item.display}</option>
                                                        ))
                                                    }
                                                </SelectBox>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('Bank Account Type', payoutDetails[i].bankType, 'required')}
                                                </Text>
                                                {payoutDetails[i].bankType === 'ISSUER_BANK' && (
                                                <>
                                                <LabelText className="mb-1">
                                                    Existing Bank Account Type
                                                </LabelText>
                                                <SelectBox
                                                    value={item.existingBankType || 'Select existing bank account type'}
                                                    onChange={(e) => {
                                                        const list = [...payoutDetails];
                                                        list[i].existingBankType = e.target.value;
                                                        setPayoutDetails(list);
                                                    }}
                                                >
                                                    <option>Select a account type</option>
                                                    {
                                                        ISSUER_BANK_ACCOUNT_TYPE.map((item) => (
                                                            <option key={item.key} value={item.value}>{item.display}</option>
                                                        ))
                                                    }
                                                </SelectBox>
                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                    {simpleValidator.current.message('Existing Bank Account Type', payoutDetails[i].existingBankType, 'required')}
                                                </Text>
                                                </>
                                                )}
                                                {item?.existingBankType === 'PLAID' && (
                                                    <>
                                                      {!item?.plaidPublicToken && !item?.externalAuth
                                                          ? (
                                                          <div className="d-flex align-items-center justify-content-center" style={{ flexDirection: 'column' }}>
                                                              <SubmitButton style={customAddBankButtonStyle} onClick={(e) => { setOpenPlaid(true); e.preventDefault(); }}>
                                                              <img style={{ verticalAlign: "sub" }} src={addIcon} alt="addIcon" /> Add Bank Account
                                                              </SubmitButton>
                                                              <Text fontSize="12px" marginTop="10px" marginBottom="0px" color="#ff1e1e">
                                                                  {simpleValidator.current.message('Bank Account', payoutDetails[i].plaidPublicToken, 'required')}
                                                              </Text>
                                                          </div>
                                                          )
                                                          : <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                              <Tag color="green">Bank Account Added</Tag>
                                                              <Tooltip title="Remove Bank">
                                                              <DeleteOutlined style={{ color: '#6b6c6f', fontSize: '18px', cursor: 'pointer' }}
                                                                  onClick={() => {
                                                                  const list = [...payoutDetails];
                                                                  list[i].plaidPublicToken = null;
                                                                  list[i].externalAuth = null;
                                                                  setPayoutDetails(list);
                                                                  }}
                                                              />
                                                              </Tooltip>
                                                          </div>
                                                      }
                                                      {openPlaid && (
                                                        <div className="d-flex align-items-center justify-content-center">
                                                          <p style={{ fontWeight: 'bold', fontSize: '18px' }}><SyncOutlined spin /> Please wait...</p>
                                                          <PlaidLinkOpener
                                                              token={plaidAccessToken}
                                                              onClose={() => {
                                                                const list = [...payoutDetails];
                                                                list[i].bankType = null;
                                                                list[i].existingBankType = null;
                                                                list[i].plaidPublicToken = null;
                                                                setPayoutDetails(list);
                                                                setOpenPlaid(false);
                                                              }}
                                                              // eslint-disable-next-line camelcase
                                                              onSuccess={(public_token, metadata) => {
                                                                // console.log('Plaid success', public_token, metadata);
                                                                const list = [...payoutDetails];
                                                                list[i].plaidPublicToken = public_token;
                                                                list[i].externalAuth = null;
                                                                setPayoutDetails(list);
                                                                setOpenPlaid(false);
                                                              }}
                                                          />
                                                        </div>
                                                      )}
                                                    </>
                                                  )}
                                                  {item?.bankType === 'ISSUER_BANK' && (
                                                  <>
                                                    <LabelText className="mb-1">
                                                      Void Check or Bank Letter/Statement
                                                    </LabelText>
                                                    <div className="d-flex">
                                                      <input type='file' style={{ color: 'transparent', marginTop: '10px' }} onChange={(e) => { handleInputChange(e, 'voidCheckUrl', i) }} />
                                                      {payoutDetails[i].voidCheckUrl && <Tag className="mt-2" color="#87d068">Uploaded</Tag>}
                                                    </div>
                                                    <label id="fileLabel" style={{ marginTop: '10px' }}>{voidCheckProof}</label>
                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                        {simpleValidator.current.message('Void Check', payoutDetails[i].voidCheckUrl, 'required')}
                                                    </Text>
                                                  </>
                                                  )}
                                                </div>
                                              )}
                                              {(bussinessDetails[0].country === 'IN' || item?.existingBankType === 'MANUAL') && (
                                                <div>
                                                    <LabelText className="mb-1">
                                                        Account Holder Name
                                                    </LabelText>
                                                    <Input
                                                        placeholder="Enter account holder name"
                                                        defaultValue={item.accountHolderName || accntName}
                                                        onChange={(e) => {
                                                            const list = [...payoutDetails];
                                                            list[i].accountHolderName = e.currentTarget.value;
                                                            setPayoutDetails(list);
                                                        }}
                                                    />
                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                        {simpleValidator.current.message('account Holder', payoutDetails[i].accountHolderName || accntName, 'required')}
                                                    </Text>
                                                    <LabelText className="mb-1">
                                                        Bank Name
                                                    </LabelText>
                                                    <Input
                                                        placeholder="Enter bank name"
                                                        value={item.bankName || bankName}
                                                        onChange={(e) => {
                                                            const list = [...payoutDetails];
                                                            list[i].bankName = e.currentTarget.value;
                                                            setPayoutDetails(list);
                                                        }}
                                                    />
                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                        {simpleValidator.current.message('bank name', payoutDetails[i].bankName || bankName, 'required')}
                                                    </Text>
                                                    <LabelText className="mb-1">
                                                        Account Number
                                                    </LabelText>
                                                    <Input
                                                        placeholder="Enter account number"
                                                        defaultValue={item.accountNumber || accntNumber}
                                                        onChange={(e) => {
                                                            const list = [...payoutDetails];
                                                            list[i].accountNumber = e.currentTarget.value;
                                                            setPayoutDetails(list);
                                                        }}
                                                    />
                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                        {simpleValidator.current.message('account Number', payoutDetails[i].accountNumber || accntNumber, 'required|validAccountNumber')}
                                                    </Text>
                                                    <LabelText className="mb-1">
                                                        Confirm Account Number
                                                    </LabelText>
                                                    <Input
                                                        placeholder="Enter account number"
                                                        defaultValue={item.confirmAccountNumber || accntNumber}
                                                        onChange={(e) => {
                                                            const list = [...payoutDetails];
                                                            list[i].confirmAccountNumber = e.currentTarget.value;
                                                            setPayoutDetails(list);
                                                        }}
                                                    />
                                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                        {simpleValidator.current.message('confirm Account Number', payoutDetails[i].confirmAccountNumber || accntNumber, `required|confirmAccount:${payoutDetails[i].accountNumber || accntNumber}`)}
                                                    </Text>
                                                    {
                                                        bussinessDetails[0].country === 'IN' ? (
                                                            <>
                                                                <LabelText className="mb-1">
                                                                    IFSC Code
                                                                </LabelText>
                                                                <Input
                                                                    placeholder="Enter IFSC number"
                                                                    defaultValue={item.bankRoutingNumber || routeNumber}
                                                                    onChange={(e) => {
                                                                        const list = [...payoutDetails];
                                                                        list[i].bankRoutingNumber = e.currentTarget.value;
                                                                        setPayoutDetails(list);
                                                                    }}
                                                                />
                                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message('IFSC code', payoutDetails[i].bankRoutingNumber || routeNumber, 'required')}
                                                                </Text>
                                                                {
                                                                    bussinessDetails[0].bussinessType === 'LIMITED_LIABILITY_PARTNERSHIP' ? (
                                                                        <>
                                                                            <LabelText className="mb-1">
                                                                                LLP ID
                                                                            </LabelText>
                                                                            <Input
                                                                                placeholder="Enter LLP ID"
                                                                                value={item.employerIdNumber}
                                                                                onChange={(e) => {
                                                                                    const list = [...payoutDetails];
                                                                                    list[i].employerIdNumber = e.currentTarget.value;
                                                                                    setPayoutDetails(list);
                                                                                }}
                                                                            />
                                                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                                {simpleValidator.current.message('LLP ID', payoutDetails[i].employerIdNumber, 'required|validLLP', { messages: { required: 'The LLP ID field is required' } })}
                                                                            </Text>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {
                                                                                bussinessDetails[0].bussinessType !== 'PROPRIETORSHIP' && (
                                                                                    <>
                                                                                        <LabelText className="mb-1">
                                                                                            CIN No.
                                                                                        </LabelText>
                                                                                        <Input
                                                                                            placeholder="Enter CIN No"
                                                                                            value={item.employerIdNumber}
                                                                                            onChange={(e) => {
                                                                                                const list = [...payoutDetails];
                                                                                                list[i].employerIdNumber = e.currentTarget.value;
                                                                                                setPayoutDetails(list);
                                                                                            }}
                                                                                        />
                                                                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                                            {simpleValidator.current.message('CIN Number', payoutDetails[i].employerIdNumber, 'required|validCIN', { messages: { required: 'The CIN field is required' } })}
                                                                                        </Text>
                                                                                    </>
                                                                                )
                                                                            }
                                                                        </>
                                                                    )
                                                                }

                                                            </>
                                                        ) : (
                                                            <>
                                                                <LabelText className="mb-1">
                                                                    Bank Routing Number
                                                                </LabelText>
                                                                <Input
                                                                    placeholder="Enter routing number"
                                                                    defaultValue={item.bankRoutingNumber || routeNumber}
                                                                    onChange={(e) => {
                                                                        const list = [...payoutDetails];
                                                                        list[i].bankRoutingNumber = e.currentTarget.value;
                                                                        setPayoutDetails(list);
                                                                    }}
                                                                />
                                                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                                                                    {simpleValidator.current.message('Routing Number', payoutDetails[i].bankRoutingNumber || routeNumber, 'required|validRoutingNumber')}
                                                                </Text>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                              )}
                                              {!isReview
                                                  && (
                                                      <>
                                                          <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                              <SubmitButton
                                                                  type="submit"
                                                                  marginTop="0px !importnat"
                                                                  marginRight="4px"
                                                                  backgroundColor="#FFFFFF"
                                                                  hoverBackgroundColor="#FFFFFF"
                                                                  color="#40A9FF"
                                                                  style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                  onClick={() => prev()}
                                                              ><Img verticalAlign='middle' src={BackArrow} /> BACK</SubmitButton>
                                                              <SubmitButton
                                                                  type="submit"
                                                                  marginTop="0px !importnat"
                                                                  marginLeft="4px"
                                                                  style={{ width: '142px' }}
                                                                  onClick={() => next()}
                                                              >NEXT <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                          </div>
                                                          <div style={{ paddingTop: '8px' }}>
                                                              <CancelButton
                                                                  style={{ width: '292px' }}
                                                                  marginTop="0px !importnat"
                                                                  onClick={() => saveAsDraft()}
                                                              >SAVE AS DRAFT</CancelButton>
                                                          </div>
                                                      </>
                                                  )}
                                              {isReview
                                                  && (
                                                      <>
                                                          <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                              <SubmitButton
                                                                  type="submit"
                                                                  marginTop="0px !importnat"
                                                                  marginRight="4px"
                                                                  backgroundColor="#FFFFFF"
                                                                  hoverBackgroundColor="#FFFFFF"
                                                                  color="#40A9FF"
                                                                  style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                                  onClick={() => updateDetails(5)}
                                                              >CANCEL</SubmitButton>
                                                              <SubmitButton
                                                                  type="submit"
                                                                  marginTop="0px !importnat"
                                                                  marginLeft="4px"
                                                                  style={{ width: '142px' }}
                                                                  onClick={() => next()}
                                                              >UPDATE</SubmitButton>
                                                          </div>
                                                          <div style={{ paddingTop: '8px' }}>
                                                              <CancelButton
                                                                  style={{ width: '292px' }}
                                                                  marginTop="0px !importnat"
                                                                  onClick={() => saveAsDraft()}
                                                              >SAVE AS DRAFT</CancelButton>
                                                          </div>
                                                      </>
                                                  )
                                              }
                                            </>
                                        ))
                                        }
                                    </>
                                )
                            }
                        </FlexContainer>
                    </div>

                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            {
                                step === 6 && (
                                    <>
                                        <LabelText className="mt-4 mb-3" style={{fontSize: '18px', fontWeight: 'bold'}}>Review Your Information</LabelText>

                                        {/* BUSINESS DETAILS SECTION */}
                                        <div style={{padding: '15px', background: '#f9f9f9', borderRadius: '8px', marginBottom: '20px'}}>
                                            <h3 className="mb-3" style={{color: '#1890ff', borderBottom: '2px solid #1890ff', paddingBottom: '8px'}}>Business Details</h3>
                                            <p className="mb-1"><strong>Country:</strong> {bussinessDetails[0].country === 'USA' ? 'United States' : bussinessDetails[0].country === 'IN' ? 'India' : bussinessDetails[0].country}</p>
                                            <p className="mb-1"><strong>Business Type:</strong> {(() => {
                                                  const types = bussinessDetails[0].country === 'USA' ? BUSINESS_TYPES.US : BUSINESS_TYPES.IN;
                                                  const type = types.find(t => t.value === bussinessDetails[0].bussinessType);
                                                  return type ? type.display : bussinessDetails[0].bussinessType;
                                              })()}
                                            </p>
                                            <p className="mb-1"><strong>Business Name:</strong> {bussinessDetails[0].name}</p>
                                            <p className="mb-1"><strong>Website:</strong> {bussinessDetails[0].website}</p>
                                            <p className="mb-1"><strong>Statement Descriptor:</strong> {bussinessDetails[0].statementDescriptor}</p>
                                            <p className="mb-1"><strong>Account Name:</strong> {bussinessDetails[0].accountName}</p>

                                            {/* US Specific Fields */}
                                            {bussinessDetails[0].country === 'USA' && (
                                                <>
                                                    <p className="mb-1"><strong>Phone Number:</strong> {bussinessDetails[0].phoneNumber}</p>
                                                    <p className="mb-1"><strong>Tax Exempt Organization:</strong> {bussinessDetails[0].isTaxExemptOrganisation}</p>
                                                    <p className="mb-1"><strong>Company Start Date:</strong> {bussinessDetails[0].companyday}/{bussinessDetails[0].companymonth + 1}/{bussinessDetails[0].companyyear}</p>
                                                    {bussinessDetails[0].employerIdNumber && (
                                                        <p className="mb-1"><strong>EIN:</strong> {bussinessDetails[0].employerIdNumber}</p>
                                                    )}
                                                </>
                                            )}

                                            {/* India Specific Fields */}
                                            {bussinessDetails[0].country === 'IN' && (
                                                <>
                                                    {bussinessDetails[0].businessPan && (
                                                        <p className="mb-1"><strong>Business PAN:</strong> {bussinessDetails[0].businessPan}</p>
                                                    )}
                                                    {bussinessDetails[0].gst && (
                                                        <p className="mb-1"><strong>GST:</strong> {bussinessDetails[0].gst}</p>
                                                    )}
                                                    {bussinessDetails[0].tan && (
                                                        <p className="mb-1"><strong>TAN:</strong> {bussinessDetails[0].tan}</p>
                                                    )}
                                                    {bussinessDetails[0].kycBankStatementUrl && (
                                                        <p className="mb-1"><strong>Bank Statement:</strong> Uploaded ✓</p>
                                                    )}
                                                    {bussinessDetails[0].kycCompanyPanUrl && (
                                                        <p className="mb-1"><strong>Company PAN Document:</strong> Uploaded ✓</p>
                                                    )}
                                                    {bussinessDetails[0].kycRegistrationProofUrl && (
                                                        <p className="mb-1"><strong>Registration Proof:</strong> Uploaded ✓</p>
                                                    )}
                                                    {bussinessDetails[0].currentAddressProofUrl && (
                                                        <p className="mb-1"><strong>Current Address Proof:</strong> Uploaded ✓</p>
                                                    )}
                                                    {bussinessDetails[0].boardResolutionUrl && (
                                                        <p className="mb-1"><strong>Board Resolution:</strong> Uploaded ✓</p>
                                                    )}
                                                    {bussinessDetails[0].gstCertificateUrl && (
                                                        <p className="mb-1"><strong>GST Certificate:</strong> Uploaded ✓</p>
                                                    )}
                                                </>
                                            )}
                                        </div>

                                        {/* REPRESENTATIVE DETAILS SECTION */}
                                        <div style={{padding: '15px', background: '#f9f9f9', borderRadius: '8px', marginBottom: '20px'}}>
                                            <h3 className="mb-3" style={{color: '#1890ff', borderBottom: '2px solid #1890ff', paddingBottom: '8px'}}>Business Representative(s)</h3>
                                            {representativeDetails.map((rep, idx) => (
                                                <div key={idx} style={{marginBottom: '15px', paddingBottom: '15px', borderBottom: idx < representativeDetails.length - 1 ? '1px solid #ddd' : 'none'}}>
                                                    <p className="mb-1" style={{fontSize: '16px', fontWeight: '600', color: '#333'}}>Representative {idx + 1}</p>
                                                    <p className="mb-1"><strong>Name:</strong> {rep.firstName} {rep.lastName}</p>
                                                    <p className="mb-1"><strong>Email:</strong> {rep.email}</p>
                                                    <p className="mb-1"><strong>Title:</strong> {rep.title}</p>
                                                    {rep.repPhoneNumber && (
                                                        <p className="mb-1"><strong>Phone:</strong> {rep.repPhoneNumber}</p>
                                                    )}
                                                    <p className="mb-1"><strong>Date of Birth:</strong> {rep.day}/{rep.month + 1}/{rep.year}</p>
                                                    <p className="mb-1"><strong>Has Control:</strong> {rep.hasControl ? 'Yes' : 'No'}</p>

                                                    {/* US Specific Representative Fields */}
                                                    {bussinessDetails[0].country === 'USA' && (
                                                        <>
                                                            {rep.ssn && (
                                                                <p className="mb-1"><strong>SSN:</strong> ***-**-{rep.ssn.slice(-4)}</p>
                                                            )}
                                                            {rep.ownerShipPercentage && (
                                                                <p className="mb-1"><strong>Ownership:</strong> {rep.ownerShipPercentage}</p>
                                                            )}
                                                            {rep.governmentIdUrl && (
                                                                <p className="mb-1"><strong>Government ID:</strong> Uploaded ✓</p>
                                                            )}
                                                        </>
                                                    )}

                                                    {/* India Specific Representative Fields */}
                                                    {bussinessDetails[0].country === 'IN' && (
                                                        <>
                                                            {rep.pan && (
                                                                <p className="mb-1"><strong>PAN:</strong> {rep.pan}</p>
                                                            )}
                                                            {rep.kycAddressProofUrl && (
                                                                <p className="mb-1"><strong>Address Proof:</strong> Uploaded ✓</p>
                                                            )}
                                                            {rep.businessRepPanUrl && (
                                                                <p className="mb-1"><strong>PAN Document:</strong> Uploaded ✓</p>
                                                            )}
                                                        </>
                                                    )}

                                                    {/* Representative Address */}
                                                    {rep.streetAddress && (
                                                        <p className="mb-1"><strong>Address:</strong> {rep.streetAddress}, {rep.city}, {rep.state} {rep.zipCode}</p>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* BUSINESS ADDRESS SECTION */}
                                        <div style={{padding: '15px', background: '#f9f9f9', borderRadius: '8px', marginBottom: '20px'}}>
                                            <h3 className="mb-3" style={{color: '#1890ff', borderBottom: '2px solid #1890ff', paddingBottom: '8px'}}>Business Address</h3>
                                            <p className="mb-1"><strong>Street Address:</strong> {bussinessAddress[0].streetAddress}</p>
                                            <p className="mb-1"><strong>City:</strong> {bussinessAddress[0].city}</p>
                                            <p className="mb-1"><strong>State:</strong> {bussinessAddress[0].state}</p>
                                            <p className="mb-1"><strong>{bussinessDetails[0].country === 'IN' ? 'Postal Code' : 'Zip Code'}:</strong> {bussinessAddress[0].zipCode}</p>
                                        </div>

                                        {/* PAYOUT DETAILS SECTION */}
                                        <div style={{padding: '15px', background: '#f9f9f9', borderRadius: '8px', marginBottom: '20px'}}>
                                            <h3 className="mb-3" style={{color: '#1890ff', borderBottom: '2px solid #1890ff', paddingBottom: '8px'}}>Payout Details</h3>
                                            {(bussinessDetails[0].country === 'IN' || payoutDetails[0].existingBankType === 'MANUAL') && (
                                              <>
                                                <p className="mb-1"><strong>Bank Name:</strong> {payoutDetails[0].bankName}</p>
                                                <p className="mb-1"><strong>Account Holder Name:</strong> {payoutDetails[0].accountHolderName}</p>
                                                <p className="mb-1"><strong>Account Number:</strong> ****{payoutDetails[0].accountNumber.slice(-4)}</p>
                                              </>
                                            )}

                                            {/* US Specific Payout Fields */}
                                            {bussinessDetails[0].country === 'USA' && isProcessingInfoRequired && (
                                                <>
                                                    {payoutDetails[0].employerIdNumber && (
                                                        <p className="mb-1"><strong>EIN:</strong> {payoutDetails[0].employerIdNumber}</p>
                                                    )}
                                                    {payoutDetails[0].averageMonthlyVolume && (
                                                        <p className="mb-1"><strong>Average Monthly Volume:</strong> ${payoutDetails[0].averageMonthlyVolume}</p>
                                                    )}
                                                    {payoutDetails[0].averageTicketAmount && (
                                                        <p className="mb-1"><strong>Average Ticket Amount:</strong> ${payoutDetails[0].averageTicketAmount}</p>
                                                    )}
                                                    {payoutDetails[0].servicesDeliveredIn && (
                                                        <p className="mb-1"><strong>When Are Goods and Services Delivered?:</strong> {(() => {
                                                              if (payoutDetails[0].servicesDeliveredIn === 'ZERO_TO_SEVEN_DAYS') return '0-7 Days';
                                                              if (payoutDetails[0].servicesDeliveredIn === 'EIGHT_TO_FOURTEEN_DAYS') return '8-14 Days';
                                                              if (payoutDetails[0].servicesDeliveredIn === 'FIFTEEN_TO_THIRTY_DAYS') return '15-30 Days';
                                                              if (payoutDetails[0].servicesDeliveredIn === 'OVER_THIRTY_DAYS') return 'Over 30 Days';
                                                              return payoutDetails[0].servicesDeliveredIn;
                                                          })()}
                                                        </p>
                                                    )}
                                                    {payoutDetails[0].refundPolicy && (
                                                        <p className="mb-1"><strong>Refund Policy:</strong> {(() => {
                                                              if (payoutDetails[0].refundPolicy === 'EXCHANGE_ONLY') return 'Exchange Only';
                                                              if (payoutDetails[0].refundPolicy === 'NO_REFUND_OR_EXCHANGE') return 'No Refund or Exchange';
                                                              if (payoutDetails[0].refundPolicy === 'MORE_THAN_THIRTY_DAYS') return 'More than 30 Days';
                                                              if (payoutDetails[0].refundPolicy === 'THIRTY_DAYS_OR_LESS') return '30 Days or Less';
                                                              return payoutDetails[0].refundPolicy;
                                                          })()}
                                                        </p>
                                                    )}
                                                    {payoutDetails[0].seasonalBusiness && (
                                                        <p className="mb-1"><strong>Seasonal Business:</strong> {payoutDetails[0].seasonalBusiness === 'true' ? 'Yes' : 'No'}</p>
                                                    )}
                                                    {payoutDetails[0].isServiceDateFlexible && (
                                                        <p className="mb-1"><strong>Service Date Flexible:</strong> {payoutDetails[0].isServiceDateFlexible === 'true' ? 'Yes' : 'No'}</p>
                                                    )}
                                                    {payoutDetails[0].whenIsCardCharged && (
                                                        <p className="mb-1"><strong>When Card is Charged:</strong> {(() => {
                                                              if (payoutDetails[0].whenIsCardCharged === 'IN_ADVANCE') return 'Yes';
                                                              if (payoutDetails[0].whenIsCardCharged === 'WHEN_SERVICE_PROVIDED') return 'No';
                                                              return payoutDetails[0].whenIsCardCharged;
                                                          })()}
                                                        </p>
                                                    )}
                                                    {payoutDetails[0].serviceyear && (
                                                        <p className="mb-1"><strong>Requested Service Date:</strong> {payoutDetails[0].serviceday}/{payoutDetails[0].servicemonth + 1}/{payoutDetails[0].serviceyear}</p>
                                                    )}
                                                    {payoutDetails[0].modeOfTransactionOnline && (
                                                        <p className="mb-1"><strong>Mode of Transaction - Online:</strong> {payoutDetails[0].modeOfTransactionOnline}</p>
                                                    )}
                                                    {payoutDetails[0].modeOfTransactionPerson && (
                                                        <p className="mb-1"><strong>Mode of Transaction - In Person:</strong> {payoutDetails[0].modeOfTransactionPerson}</p>
                                                    )}
                                                    {payoutDetails[0].isEbt && (
                                                        <p className="mb-1"><strong>EBT:</strong> {payoutDetails[0].isEbt ? 'Yes' : 'No'}</p>
                                                    )}
                                                    {payoutDetails[0].voidCheckUrl && (
                                                        <p className="mb-1"><strong>Void Check:</strong> Uploaded ✓</p>
                                                    )}
                                                </>
                                            )}

                                            {/* India Specific Payout Fields */}
                                            {bussinessDetails[0].country === 'IN' && (
                                                <>
                                                    {payoutDetails[0].bankRoutingNumber && (<p className="mb-1"><strong>IFSC Code:</strong> {payoutDetails[0].bankRoutingNumber}</p>)}
                                                    {payoutDetails[0].employerIdNumber && (
                                                        <p className="mb-1"><strong>CIN:</strong> {payoutDetails[0].employerIdNumber}</p>
                                                    )}
                                                </>
                                            )}
                                        </div>

                                        <Text className="mt-3" style={{color: '#666', fontStyle: 'italic', padding: '10px', background: '#fff3cd', borderRadius: '4px', border: '1px solid #ffc107'}}>
                                            ⚠️ Please review all the information above carefully before proceeding to submit.
                                        </Text>

                                        {!isReview && (
                                            <>
                                                <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                    <SubmitButton
                                                        type="submit"
                                                        marginTop="0px !importnat"
                                                        marginRight="4px"
                                                        backgroundColor="#FFFFFF"
                                                        hoverBackgroundColor="#FFFFFF"
                                                        color="#40A9FF"
                                                        style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                        onClick={() => prev()}
                                                    ><Img verticalAlign='middle' src={BackArrow} /> BACK</SubmitButton>
                                                    <SubmitButton
                                                        type="submit"
                                                        marginTop="0px !importnat"
                                                        marginLeft="4px"
                                                        style={{ width: '142px' }}
                                                        onClick={() => next()}
                                                    >NEXT <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                                </div>
                                                <div style={{ paddingTop: '8px' }}>
                                                    <CancelButton
                                                        style={{ width: '292px' }}
                                                        marginTop="0px !importnat"
                                                        onClick={() => saveAsDraft()}
                                                    >SAVE AS DRAFT</CancelButton>
                                                </div>
                                            </>
                                        )}
                                        {isReview && (
                                            <>
                                                <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                                    <SubmitButton
                                                        type="submit"
                                                        marginTop="0px !importnat"
                                                        marginRight="4px"
                                                        backgroundColor="#FFFFFF"
                                                        hoverBackgroundColor="#FFFFFF"
                                                        color="#40A9FF"
                                                        style={{ width: '142px', border: '1px solid #40A9FF' }}
                                                        onClick={() => updateDetails(5)}
                                                    >CANCEL</SubmitButton>
                                                    <SubmitButton
                                                        type="submit"
                                                        marginTop="0px !importnat"
                                                        marginLeft="4px"
                                                        style={{ width: '142px' }}
                                                        onClick={() => next()}
                                                    >UPDATE</SubmitButton>
                                                </div>
                                                <div style={{ paddingTop: '8px' }}>
                                                    <CancelButton
                                                        style={{ width: '292px' }}
                                                        marginTop="0px !importnat"
                                                        onClick={() => saveAsDraft()}
                                                    >SAVE AS DRAFT</CancelButton>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )
                            }
                        </FlexContainer>
                    </div>

                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            {
                                step === 7 && (
                                    <>
                                        <LabelText className="mt-4 mb-2">
                                            BUSINESS DETAILS
                                        </LabelText>
                                        <InputWrapper marginBottom="0px" paddingRight='5px' borderRadius="4px">
                                            <Input
                                                value={bussinessDetails[0].name}
                                                style={{
                                                    margin: "0px",
                                                    border: "0px",
                                                    width: "268px",
                                                }}
                                                type="readOnly"
                                            />
                                            <Img verticalAlign='middle' onClick={() => updateDetails(1)} src={EditIcon} />
                                        </InputWrapper>
                                        <LabelText className="mt-4 mb-2">
                                            BUSINESS REPRESENTATIVE
                                        </LabelText>
                                        <InputWrapper marginBottom="0px" paddingRight='5px' borderRadius="4px">
                                            <Input
                                                value={`${representativeDetails[0].firstName ? representativeDetails[0].firstName : givenName} ${representativeDetails[0].lastName ? representativeDetails[0].lastName : familyName}`}
                                                style={{
                                                    margin: "0px",
                                                    border: "0px",
                                                    width: "268px",
                                                }}
                                                type="readOnly"
                                            />
                                            <Img verticalAlign='middle' onClick={() => updateDetails(2)} src={EditIcon} />
                                        </InputWrapper>
                                        <LabelText className="mt-4 mb-2">
                                            BUSINESS ADDRESS
                                        </LabelText>
                                        <InputWrapper marginBottom="0px" paddingRight='5px' borderRadius="4px">
                                            <Input
                                                value={`${bussinessAddress[0].streetAddress}, ${bussinessAddress[0].city}`}
                                                style={{
                                                    margin: "0px",
                                                    border: "0px",
                                                    width: "268px",
                                                }}
                                                type="readOnly"
                                            />
                                            <Img verticalAlign='middle' onClick={() => updateDetails(3)} src={EditIcon} />
                                        </InputWrapper>
                                        {bussinessDetails[0].country === 'IN' && (
                                          <>
                                            <LabelText className="mt-4 mb-2">
                                                PAYOUT DETAILS
                                            </LabelText>
                                            <InputWrapper marginBottom="0px" paddingRight='5px' borderRadius="4px">
                                                <Input
                                                    value={payoutDetails[0].accountHolderName || accntName}
                                                    style={{
                                                        margin: "0px",
                                                        border: "0px",
                                                        width: "268px",
                                                    }}
                                                    type="readOnly"
                                                />
                                                <Img verticalAlign='middle' onClick={() => updateDetails(4)} src={EditIcon} />
                                            </InputWrapper>
                                          </>
                                        )}
                                        <Text className="mt-2 mb-2" fontSize="14px" marginTop="4px" marginBottom="1px" style={{ width: '292px' }}>
                                            By clicking Submit, you agree to
                                            <span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => window.open("https://policies.swirepay.com/")}> Swirepay terms of service</span>
                                            and you certify that the information you have provided to Swirepay is complete and correct.
                                        </Text>
                                        <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                                            <SubmitButton
                                                style={{ width: '292px' }}
                                                type="submit"
                                                marginTop="0px !importnat"
                                                onClick={() => next()}
                                                disabled={errorMessage && showerrorMessage}
                                            >SUBMIT</SubmitButton>
                                        </div>
                                        {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                                    </>
                                )
                            }
                        </FlexContainer>
                    </div>

                </FlexContainer>
                {policyConfirmation && (
                  <PolicyConfirmationModal
                    visible={policyConfirmation}
                    submit={onSubmitPolicy}
                  />
                )}
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} partnerConnection={true} />
                <Spinner isOpen={isShowSpinner} />
                <SuccessModal
                  isOpen={unProceed}
                  message={"Thank you for choosing us!"}
                  pauseType={"We are unable to proceed with onboarding at this time. We appreciate your understanding. For further queries contact us at support@swirepay.com"}
                />
            </>
        } />
    )
};

export default PartnerBusiness;
